import React from "react";
import {
  Container,
  Tabs,
  Tab,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Form,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { InfoTooltip } from "../../Common/Components/InfoTooltip";
import { accountService } from "../../Common/Services/account";
import { CommonService } from "../../Common/Services/CommonService";
import Dropzone from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import { resolve, reject } from "q";
import "../Register/slideout.scss";
import DatePicker from "react-datepicker";
import { Support } from "../../Common/Components/Support";
import { OtpModal } from "../../Common/Components/OtpModal";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { confirmAlert } from "react-confirm-alert";
import { faCloudShowersHeavy } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { PlaidSetup } from "../../Common/ThirdPartyServices/PlaidSetup";
import { Utils } from "../../Common/Utilis";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";
import { FundingOptionModal } from "./FundingOptionModal";
import { VerifyMicroDepositModal } from "./VerifyMicroDepositModal";
import { Hotel as hotel } from "../../Common/Services/Hotel";
import { SetupBankSync } from "../Accounting/BankSync/SetupBankSync";

var PlaidLink = require("react-plaid-link");
let localStorageUser: any;
export class BankAccountSlideout extends React.Component<any, any> {
  private parentScroll: any;
  private coaRef: any;
  private openingDateRef: any;
  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.coaRef = React.createRef();
    this.openingDateRef = React.createRef();
    this.state = {
      BlobbaseUrl: "",
      actionType: this.props.actionType,
      actionTypeBankSync: this.props.actionType,
      mode: "0",
      transactions: [],
      showChoiceModal: false,
      showVerifyModal: false,
      // hotelName: this.props.hotelName,
      // hotelID: this.props.hidValue,
      hidList: [],
      hidFilterList: [],
      hotelID: "Select",
      hotelName: "Select",
      isSpinner: false,
      isOtpNeed: false,
      otpSuccess: false,
      enableDACH: "No",
      activeTab: props?.callFrom === "accountsPage" || props?.callFrom === "BankSync" ? "banksync" : "general",
      isDiscardChanges: false,
      handleBankNotListedModal: false,
      showInactivePopup: false,
      isPlaidSetupButton: false,
      calendarOpened: false,
      isUpdatation: false,
      calenderSelectDate: Utils.getHotalCurrentDate(),
      isShowSensitiveFields: "",
      isLimitedSubscription: "No",
      files: [],
      selectedFiles: [],
      digitalSign: "",
      isEditOperating: "",
      isEditMisc: "",
      isEditPayroll: "",
      fileName: "",
      coaList: [],
      selectedCOA: [],
      lastActiveStatus: "",
      plaidbtnStatus: "",
      plaidStatus: "",
      isButton: false,
      fundingSource: "",
      moreActionSignature: [
        { name: "Delete", eventKey: "delete" },
        { name: "Download", eventKey: "download" },
      ],
      accountType: [
        { id: "O", name: "Operating Bank Account" },
        { id: "M", name: "Miscellaneous Bank Account" },
        { id: "P", name: "Payroll Bank Account" },
        // {id:"C", Name:"Credit Card Accounts"}
      ],
      selectedAccount: { id: "", name: "" },
      existingBankAccount: [],
      selectedExistAcc: { oprID: -1, hotelID: 0, tenantID: 0, obaccno: "" },
      isExistAcc: false,
      payFileformatList: [],
      selectedPayFormat: [],
      formData: {
        id: 0,
        oprID: -1,
        obaccno: "",
        accountName: "",
        routing: "",
        hotelID: this.props.hidValue,
        bankName: "",
        openingDate: "",
        bankNo: "",
        opnBal: 0,
        lastChkno: "",
        digitalSignaturelimit: "",
        series: "",
        bankAddress: "",
        bankCity: "",
        bankCountry: "",
        bankState: "",
        bankPostalCode: "",
        status: "Active",
        acctType: "",
        splitOpeningbalance: 0,
        bankAddress2: "",
        cCity: "",
        cCountry: "",
        cState: "",
        cStreet: "",
        cPostalCode: "",
        bankStreet: "",
        displayName: "",
        owner: "",
        setDefault: "No",
        coa: "",
        payFileformatID: 0,
        payFileformatName: "",
        digitalSignatureImg: "",
        companyCode: "",
        imageUsername: "",
        isrepeat: 0,
        searchable: "Yes",
        isEPayEnable: 0,
        isEpayToggleChange: false
      },
      errors: {
        accountType: "",
        txtAccount: "",
        txtnickname: "",
        txtbankCode: "",
        openingACBalance: "",
        bankStreetAddress1: "",
        bankStreetAddress2: "",
        coa: "",
        accountName: "",
        bankName: "",
        openingDate: "",
        ABARoutingNo: "",
        StartingCheckNo: "",
        checkSeries: "",
        cStreet: "",
        cCity: "",
        cCountry: "",
        cState: "",
        cPostalCode: "",
        companyCode: "",
      },
      bankSyncOn: false,
      pullTransDays: "",
      isBankSyncDone: false,
      plaidConnectionStatus: "",
      bankSyncPerm: false,
      connectedAcctName: this.props?.accountName,
      opdIDPlaid: this.props.oprID,
      accDisplayNamePlaid: this.props.accDisplayName,
      isNewAccountAdded: false,
      accountOpeningDate: "",
      isBankSyncFeatureFlag: false,
      isCustIDPresent: false,
      isLastAccount: false,
      ePayFeatureStatus: "",
      epayToggleOldState: false,
    };
    this.onDrop = this.onDrop.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    // this.featureFlagForTenant=this.featureFlagForTenant.bind(this);
  }

  componentDidMount() {
    this.featureFlagForTenant();
    this.setState({ isSpinner: true, isNewAccountAdded: false });
    this.loadEHIDList();
    this.getBlobbaseUrl();
  }

  getBlobbaseUrl = () => {

    let keyName = "BlobbaseUrl";
    let BlobbaseUrl = "";
    CommonService.GetInnflowConfigKeyValue(keyName)
      .then(async (result: any | null) => {
        console.log(result);
        if (result !== null) {
          BlobbaseUrl = result;
          this.setState({ BlobbaseUrl: BlobbaseUrl });
        }

      });
  }


  featureFlagForTenant = () => {
    let { isBankSyncFeatureFlag } = this.state;
    isBankSyncFeatureFlag = false;
    accountService.GetFeatureFlagForTenant()
      .then(async (result: any | null) => {
        if (result !== null) {
          isBankSyncFeatureFlag = result.some((o: any) => o?.featureValue?.toString().toLowerCase() === "bank sync" && o?.featureStatus?.toString().toLowerCase() === "yes");
        }
        this.setState({ isBankSyncFeatureFlag });
      });
  }

  loadEHIDList = () => {
    localStorageUser = JSON.parse(localStorage.getItem("storage")!);
    const hotelID = JSON.parse(localStorage.getItem("hotelid")!);
    const hotelName = JSON.parse(localStorage.getItem("hotelName")!);
    if (this.state.actionType === "edit") {
      hotel
        .UserHotelAccessAccounts(this.props.oprID)
        .then(async (result: any[] | null) => {
          if (result != null && result.length > 0) {
            const pullTransDays = result[0]?.pullTransDays;
            let ownerEHID = result;//result.filter((o) => o?.owner?.toLowerCase() === "y");
            // if (ownerEHID.length <= 0 && result.length == 1) {
            //   ownerEHID = result;
            // } else if (ownerEHID.length <= 0 && result.length > 1) {
            //   ownerEHID = result[0];
            // }
            let { formData } = this.state;
            formData.hotelID = ownerEHID[0].hotelID
            this.setState({
              hidFilterList: result, pullTransDays: pullTransDays, hotelName: ownerEHID[0].lettercode,
              hotelID: ownerEHID[0].hotelID,
              formData,
              isNewAccountAdded: false
            },()=>{
              console.log(this.state.formData);
              
            });
            if (hotelName === null) {
              this.setState({ hidList: result });
              if (result.length > 1) {
                this.setState(
                  {
                    hotelName: ownerEHID[0].lettercode,
                    hotelID: ownerEHID[0].hotelID,//this.state.hidList[0].hotelID,
                  },
                  () => {
                    this.PlaidSetupDetails();
                    PlaidSetup.IntegratePlaid1();
                    this.bindPositivePayFormat();
                    this.getSignatureImgPerm();
                    this.getCOAList();
                  }
                );
              }
            } else {
              this.setState({ hotelName: hotelName });
            }
            if (hotelID === null) {
              if (result.length === 1) {
                this.setState(
                  {
                    hotelName: ownerEHID[0].lettercode,
                    hotelID: ownerEHID[0].hotelID,//this.state.hidList[0].hotelID,
                  },
                  () => {
                    this.PlaidSetupDetails();
                    PlaidSetup.IntegratePlaid1();
                    this.bindPositivePayFormat();
                    this.getSignatureImgPerm();
                    this.getCOAList();
                  }
                );
              }
            } else {
              this.setState({ hotelID: hotelID }, () => {
                this.PlaidSetupDetails();
                PlaidSetup.IntegratePlaid1();
                this.bindPositivePayFormat();
                this.getSignatureImgPerm();
                this.getCOAList();
              });
            }
          }
          resolve();
        })
        .catch((error) => {
          Utils.toastError(`Server Error: ${error}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "AccountsHome"
          });
          reject();
        });
    } else if (this.state.actionType === "new") {
      hotel.getUserHotelAccess("Accounting")
        .then(async (result: any[] | null) => {
          if (result != null && result.length > 0) {
            let ownerEHID = result.filter((o) => o?.hotelID === this.props.hidValue
            );
            console.log(ownerEHID)
            let { formData } = this.state;
            formData.hotelID = ownerEHID[0].hotelID
            this.setState({
              hidFilterList: result, hotelName: ownerEHID[0].lettercode,
              hotelID: ownerEHID[0].hotelID,
              formData, isNewAccountAdded: false
            });
            if (hotelName === null) {
              this.setState({ hidList: result });
              if (result.length > 1) {
                this.setState(
                  {
                    hotelName: ownerEHID[0].lettercode,
                    hotelID: ownerEHID[0].hotelID,//this.state.hidList[0].hotelID,
                  },
                  () => {
                    this.PlaidSetupDetails();
                    PlaidSetup.IntegratePlaid1();
                    this.bindPositivePayFormat();
                    this.getSignatureImgPerm();
                    this.getCOAList();
                  }
                );
              }
            } else {
              this.setState({ hotelName: hotelName });
            }
            if (hotelID === null) {
              if (result.length === 1) {
                this.setState(
                  {
                    hotelName: ownerEHID[0].lettercode,
                    hotelID: ownerEHID[0].hotelID,//this.state.hidList[0].hotelID,
                  },
                  () => {
                    this.PlaidSetupDetails();
                    PlaidSetup.IntegratePlaid1();
                    this.bindPositivePayFormat();
                    this.getSignatureImgPerm();
                    this.getCOAList();
                  }
                );
              }
            } else {
              this.setState({ hotelID: hotelID }, () => {
                this.PlaidSetupDetails();
                PlaidSetup.IntegratePlaid1();
                this.bindPositivePayFormat();
                this.getSignatureImgPerm();
                this.getCOAList();
              });
            }
          }
          resolve();
        })
        .catch((error) => {
          Utils.toastError(`Server Error: ${error}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "AccountsHome"
          });
          reject();
        }).finally(() => {
          setTimeout(() => this.setState({ isSpinner: false }));
        });;
    }
  }

  handleVerifyModal = () => {
    this.setState({ showVerifyModal: !this.state.showVerifyModal });
  };

  //This is called when the user change the selected hotel
  hotelChange = (hotelDetails: any) => {
    if (sessionStorage.getItem("hotelSelected"))
      sessionStorage.removeItem("hotelSelected");
    sessionStorage.setItem("hotelSelected", JSON.stringify(hotelDetails));

    if (localStorage.getItem("hotelSelected"))
      localStorage.removeItem("hotelSelected");
    localStorage.setItem("hotelSelected", JSON.stringify(hotelDetails));

    let { formData } = this.state;
    formData.hotelID = hotelDetails.hotelID;
    this.setState(
      {
        hotelName: hotelDetails.lettercode,
        hotelID: hotelDetails.hotelID,
        formData
      },
      () => {
        this.PlaidSetupDetails();
        PlaidSetup.IntegratePlaid1();
        this.bindPositivePayFormat();
        this.getSignatureImgPerm();
        this.getCOAList();
      }
    );
  };

  //This is method is used for filter the data on three columns (Account no, Account Type and Bank)
  searchItems = (e: any) => {
    const { hidFilterList } = this.state;
    let result = e.target.value;
    this.setState({ search: result });
    if (result !== "") {
      this.setState({
        hidList: hidFilterList.filter((hName: any) =>
          hName.hotelName.toLowerCase().includes(result.toLowerCase().trim())
        ),
      });
    } else {
      this.setState({ hidList: this.state.hidFilterList });
    }
  };

  PlaidSetupDetails = () => {
    let request: any = {};
    request.hotelID = this.state.hotelID; //ExistingFundingSource
    request.oprID = this.state.opdIDPlaid;
    request.acctType = this.state.actionType === "new" ? "" : this.props?.acctType?.toLowerCase() === "o" ? "OPR" :
      this.props?.acctType?.toLowerCase() === "p" ? "PAY" :
        this.props?.acctType?.toLowerCase() === "m" ? "MIS" : "CC";
    accountService
      .PlaidSetupDetails(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          const isBankSetupDone = result?.isPlaidSetupForAccount;
          const plaidConnectionStatus = result?.plaidConnectionStatus;
          const bankSyncPerm = result?.bankSyncPerm;
          const accountOpeningDate = result?.accountOpeningDate;
          const isCustIDPresent = result?.isCustIDPresent;
          this.setState({
            isBankSyncDone: isBankSetupDone === "Setup Complete",
            bankSyncOn: isBankSetupDone === "Setup Complete",
            plaidConnectionStatus: plaidConnectionStatus,
            bankSyncPerm: bankSyncPerm,
            accountOpeningDate: accountOpeningDate,
            activeTab: plaidConnectionStatus?.toLowerCase() === "reconnect" ? "banksync" : this.state.activeTab,
            isCustIDPresent
          })
        }
      });
  }

  scrollToBottom = () => {
    this.parentScroll.current.scrollTo({
      //top: this.parentScroll.current.clientHeight,
      top: this.parentScroll.current.scrollHeight,
      behavior: "smooth",
    });
  };
  // Calender
  changeDate = (datee: any) => {
    let formData = { ...this.state.formData };
    let errors = this.state.errors;
    let calenderYeare = datee.getFullYear().toString().substr(2, 4);
    let calenderDatee =
      datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
    let calenderMonthe =
      datee.getMonth() + 1 > 9
        ? datee.getMonth() + 1
        : 0 + "" + (datee.getMonth() + 1);
    let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
    errors.openingDate = "";

    formData.openingDate = tempDatee;
    errors.openingDate =
      tempDatee.trim().length === 0 ? "Please enter opening date." : "";
    this.setState({
      errors,
      formData,
      calenderSelectDate: datee,
      calendarOpened: false,
      isDiscardChanges: true,
    });
  };

  openCalendar = () => {
    if (!this.IsFielsDisabled()) {
      this.setState({ calendarOpened: true });
    }
  };

  calenderHide = () => {
    this.setState({ calendarOpened: false });
  };

  getCOAList() {
    let request: any = {};
    request.hotelID = this.state.hotelID;
    accountService.COADetailsBank(request).then(async (result: any | null) => {
      if (result !== null) {
        let coaArray: any = [];
        result.forEach((element) => {
          let coalistdup: any = {};
          coalistdup.id = element.coa;
          coalistdup.label = element.coaName;
          coaArray.push(coalistdup);
        });
        this.setState({ coaList: coaArray });
      }
    });
  }
  keyDown(event) {
    if (
      event.keyCode === 8 ||
      event.keyCode === 46 ||
      event.keyCode === 37 ||
      event.keyCode === 39 ||
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    ) {
    } else {
      event.preventDefault();
    }
  }
  onCOAInputChange(val, refName) {
    if (val.trim().length > 5) {
      let currentVal = val.slice(0, 5);
      refName.current.inputNode.value = currentVal;
      refName.current.state.text = currentVal;
      val = currentVal;
    }
    let errors = this.state.errors;
    let formData = { ...this.state.formData };
    errors.coa = val.trim().length === 0 ? "Please enter COA." : "";
    if (!isNaN(val)) {
      if (val.trim().length === 5) {
        formData.coa = val.trim();
        this.setState({ selectedCOA: [{ id: val, label: val }] });
      } else {
        errors.coa = "COA should be five digits.";
      }
    }
    this.setState({
      errors,
      formData,
      selectedCOA: [],
      isDiscardChanges: true,
    });
  }

  handleCOA(val: any) {
    this.setState({ selectedCOA: val });
  }

  getSignatureImgPerm() {
    let request: any = {};
    request.hotelID = this.state.hotelID;
    accountService
      .DigitalSignPermission(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            digitalSign: result[0].digitalSign,
            isEditOperating: result[0].isEditOperating,
            isEditMisc: result[0].isEditMisc,
            isEditPayroll: result[0].isEditPayroll,
            isShowSensitiveFields: result[0].isShowSensitiveFields,
            isLimitedSubscription: result[0].isLimitedSubscription,
          });
          if (result[0].hotelType === "2") {
            let accountType: any = [];
            if (result[0].isEditOperating === "Yes") {
              accountType.push({ id: "O", name: "Operating Bank Account" });
            }
            if (result[0].isEditMisc === "Yes") {
              accountType.push({ id: "M", name: "Miscellaneous Bank Account" });
            }
            if (
              result[0].isEditPayroll === "Yes" &&
              result[0].isLimitedSubscription === "No"
            ) {
              accountType.push({ id: "P", name: "Payroll Bank Account" });
            }
            this.setState({ accountType });
          } else {
            let accountType: any = [];
            if (result[0].isEditOperating === "Yes") {
              accountType.push({ id: "O", name: "Operating Bank Account" });
            }
            if (
              result[0].isEditPayroll === "Yes" &&
              result[0].isLimitedSubscription === "No"
            ) {
              accountType.push({ id: "P", name: "Payroll Bank Account" });
            }

            this.setState({ accountType });
          }

          if (
            this.state.actionType === "edit" &&
            (result[0].isEditOperating === "No" ||
              result[0].isEditMisc === "No" ||
              result[0].isEditPayroll === "No")
          ) {
            let accountType: any = [];
            if (result[0].isEditOperating === "No") {
              accountType.push({ id: "O", name: "Operating Bank Account" });
            }
            if (result[0].isEditMisc === "No") {
              accountType.push({ id: "M", name: "Miscellaneous Bank Account" });
            }
            if (result[0].isEditPayroll === "No") {
              accountType.push({ id: "P", name: "Payroll Bank Account" });
            }
            this.setState({ accountType });
          }
        }

        if (this.state.actionType === "edit") {
          this.setState({
            selectedAccount: this.state.accountType.filter(
              (e) => e.id === this.props.acctType
            )[0],
          });
          let storage = JSON.parse(localStorage.getItem("storage")!);
          let tenantID = storage === null ? 0 : (storage.tenantID as any);
          let selectedExistAcc = { ...this.state.selectedExistAcc };
          selectedExistAcc.oprID = this.props.oprID;
          selectedExistAcc.hotelID = this.state.hotelID;
          selectedExistAcc.tenantID = tenantID;
          selectedExistAcc.obaccno = ""; //id: -1, hotelID: -1, tenantID:-1, obaccno: ""
          this.bindFormData(selectedExistAcc);
        }
      });
  }

  bindPositivePayFormat() {
    let request: any = {};
    request.hotelID = this.state.hotelID; //ExistingBankAccDetails
    accountService
      .PositivePayFileDetails(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          let payList: any = [];

          result.forEach(element => {
            let payItem: any = {};
            payItem.id = element.id;
            payItem.label = element.payFileFormat;
            payList.push(payItem);

          });

          console.log(payList);

          this.setState({ payFileformatList: payList });
        }
      });
  }

  bindFundingSource() {
    let request: any = {};
    request.hotelID = this.state.hotelID; //ExistingFundingSource
    request.bankRefID = this.state.formData.id;
    accountService
      .GetFundingSource(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          //debugger;
          console.log(result);
          this.setState({
            fundingSource: result,
          });
        }
      });
  }

  handleTabSelect = (eventKey: any) => {
    if (this.state.actionType === "edit") {
      if (this.state.isDiscardChanges) {
        confirmAlert({
          title: "Unsaved confirmation",
          message:
            "You have unsaved changes on this page. Do you want to save this page changes?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.saveBankDetails(),
            },
            {
              label: "No",
              onClick: () => reject(),
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.setState({ activeTab: eventKey });
      }
    } else {
      if (this.isFormValidate()) {
        this.setState({ activeTab: eventKey });
      }
    }
  };

  handleAccountSelect = (item) => {
    let errors = { ...this.state.errors };
    let formData = { ...this.state.formData };
    let selectedAccount = { ...this.state.selectedAccount };
    formData.acctType = item.id;
    selectedAccount.id = item.id;
    selectedAccount.name = item.name;
    errors.accountType = "";
    this.coaRef.current.inputNode.value = "";
    this.coaRef.current.state.text = "";
    this.setState(
      {
        selectedAccount,
        formData,
        errors,
        selectedCOA: [],
        isDiscardChanges: true,
      },
      () => {
        this.resetControls();
        this.loadExistingAccounts(item.id);
      }
    );
  };

  loadExistingAccounts(accType) {
    let request: any = {};
    request.accttype = accType;
    request.hotelID = this.state.hotelID;
    accountService
      .ExistingBankAccDetails(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          console.log(result);
          this.setState({
            existingBankAccount: result,
            selectedExistAcc: {
              oprID: -1,
              hotelID: -1,
              tenantID: -1,
              obaccno: "Select",
            },
          });
        }
      });
  }

  handleExistAccountSelect = (item) => {
    let selectedExistAcc = { ...this.state.selectedExistAcc };
    selectedExistAcc.oprID = item.oprID;
    selectedExistAcc.hotelID = item.hotelID;
    selectedExistAcc.tenantID = item.tenantID;
    selectedExistAcc.obaccno =
      this.state.isShowSensitiveFields === "Yes"
        ? item.obaccno
        : item.obaccnored; //id: -1, hotelID: -1, tenantID:-1, obaccno: ""
    this.setState(
      {
        files: [],
        selectedFiles: [],
        selectedCOA: [],
        selectedExistAcc,
        isExistAcc: true,
        errors: {
          accountType: "",
          txtAccount: "",
          txtnickname: "",
          txtbankCode: "",
          openingACBalance: "",
          bankStreetAddress1: "",
          bankStreetAddress2: "",
          coa: "",
          accountName: "",
          bankName: "",
          openingDate: "",
          ABARoutingNo: "",
          StartingCheckNo: "",
          checkSeries: "",
          cStreet: "",
          cCity: "",
          cCountry: "",
          cState: "",
          cPostalCode: "",
          companyCode: "",
        },
      },
      () => {
        if (item.id === -1) {
          this.resetControls();
        } else {
          this.bindFormData(selectedExistAcc);
        }
      }
    );
  };

  resetControls() {
    let searchable = (this.state.selectedAccount.id.toString().toLowerCase() === 'p' ? "No" : "Yes");
    this.setState({
      isExistAcc: false,
      files: [],
      selectedFiles: [],
      selectedCOA: [],
      selectedPayFormat: [],
      formData: {
        id: 0,
        oprID: -1,
        obaccno: "",
        accountName: "",
        routing: "",
        hotelID: this.state.hotelID,
        bankName: "",
        openingDate: "",
        bankNo: "",
        opnBal: 0,
        lastChkno: "",
        digitalSignaturelimit: "",
        series: "",
        bankAddress: "",
        bankCity: "",
        bankCountry: "",
        bankState: "",
        bankPostalCode: "",
        status: "Active",
        acctType: this.state.selectedAccount.id,
        splitOpeningbalance: 0,
        bankAddress2: "",
        cCity: "",
        cCountry: "",
        cState: "",
        cStreet: "",
        cPostalCode: "",
        bankStreet: "",
        displayName: "",
        owner: "",
        setDefault: "No",
        coa: "",
        payFileformatID: 0,
        payFileformatName: "",
        digitalSignatureImg: "",
        companyCode: "",
        imageUsername: "",
        isrepeat: 0,
        searchable: searchable
      },

    });
  }
  //This function is for Old controll
  // handlePayFormatSelect = (item) => {
  //   let formData = { ...this.state.formData };
  //   formData.payFileformatID = item.id;
  //   formData.payFileformatName = item.payFileFormat;
  //   this.setState({ formData, isDiscardChanges: true });
  // };

  //This function is for New controll
  handlePayFormatSelect = (val) => {

    let formData = { ...this.state.formData };
    // let formData = { ...this.state.formData };
    // formData.payFileformatID = item.id;
    // formData.payFileformatName = item.payFileFormat;
    // this.setState({ formData, isDiscardChanges: true });
  };

  handleSelectedItem = (control: any) => {
    let formData = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    if (control.length > 0) {
      formData.payFileformatID = control[0].id;
      formData.payFileformatName = control[0].label;
      this.setState({ formData, selectedPayFormat: control, isDiscardChanges: true },()=>{
        console.log(this.state.formData);
      });
    }
  }

  handleTypeaheadInput = (input) => {

    let formData = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    let selectedPayFormat: any = [];
    if (input.length > 0) {
      if (this.state.payFileformatList.filter((x) => x.label.toLowerCase() === input.toLowerCase()).length > 0) {
        const index = this.state.payFileformatList.findIndex((x) => x.label.toLowerCase() === input.toLowerCase());
        formData.payFileformatID = this.state.payFileformatList[index].id;
        formData.payFileformatName = this.state.payFileformatList[index].label;
        selectedPayFormat.push(this.state.payFileformatList[index]);
      }
      else {
        formData.payFileformatID = -1;
        formData.payFileformatName = "";
        selectedPayFormat.push({id: -1, label: input});
      }
    }
    else {
      formData.payFileformatID = -1;
      formData.payFileformatName = "";
    }
    this.setState({ formData, isDiscardChanges: true, selectedPayFormat,  });
  };

  handleTypeaheadBlur = () => {
    let formData = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    let selectedPayFormat = Object.assign([], JSON.parse(JSON.stringify(this.state.selectedPayFormat)));
    if (this.state.selectedPayFormat.length > 0) {
      if (this.state.selectedPayFormat[0].id === -1) {
        if (this.state.payFileformatList.filter((x) => x.label.toLowerCase() === this.state.selectedPayFormat[0].label.toLowerCase()).length > 0) {
          const index = this.state.payFileformatList.findIndex((x) => x.label.toLowerCase() === this.state.selectedPayFormat[0].label.toLowerCase());
          formData.payFileformatID = this.state.payFileformatList[index].id;
          formData.payFileformatName = this.state.payFileformatList[index].label;
          selectedPayFormat = [];
          selectedPayFormat.push(this.state.payFileformatList[index]);
        }
        else {
          formData.payFileformatID = -1;
          formData.payFileformatName = "";
          selectedPayFormat = [];
        }
        this.setState({ formData, isDiscardChanges: true, selectedPayFormat,  });
      }
    }
  }


  bindFormData(request) {
    this.setState({ isSpinner: true });
    accountService
      .BankAccDetailsRes(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          const isLastAccount = result[0].ePayCountEHIDWise === 1;
          const ePayFeatureStatus = result[0].ePayFeatureStatus;
          let datee = new Date(result[0].openingDate);
          let calenderYeare = datee.getFullYear().toString().substr(2, 4);
          let calenderDatee =
            datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
          let calenderMonthe =
            datee.getMonth() + 1 > 9
              ? datee.getMonth() + 1
              : 0 + "" + (datee.getMonth() + 1);
          let tempDatee =
            calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
          result[0].openingDate = tempDatee;
          this.setState({
            calenderSelectDate: datee,
            formData: result[0],
            isSpinner: false,
            lastActiveStatus: result[0].status,
            isLastAccount,
            ePayFeatureStatus,
            epayToggleOldState: result[0]?.isEPayEnable,
          },()=>{

            let selectedpayFormat : any =[];
            let payitem : any ={};
            payitem.id =this.state.formData.payFileformatID;
            payitem.label =this.state.formData.payFileformatName;
            selectedpayFormat.push(payitem);
            this.setState({selectedPayFormat:selectedpayFormat});
           console.log(this.state.formData);
          });
          if (result[0].digitalSignatureImg.length > 0) {
            this.setState({
              files: [
                {
                  preview:
                    "data:image/png;base64," + result[0].digitalSignatureImg,
                  name: "Uploaded by " + result[0].imageUsername,
                  uploaddatetime: Utils.getDateTimeMddyyFromUtc(result[0].uploaddatetime),
                },
              ],
            });
            this.setState({ fileName: result[0].fileName });
          }
          if (this.state.actionType === "edit") {
            this.PlaiddSetupStatus(result[0].hotelID, result[0].id);
            this.PlaiddSetupButtonPermission(result[0].hotelID);
            this.setState({
              selectedExistAcc: {
                oprID: result[0].oprID,
                hotelID: result[0].hotelID,
                tenantID: result[0].tenantID,
                obaccno:
                  this.state.isShowSensitiveFields === "Yes"
                    ? result[0].obaccno
                    : result[0].accountNo,
              },
            });
          }
          this.handleCOA([{ id: result[0].coa, label: result[0].coa }]);
          this.bindFundingSource();
        } else {
          this.setState({ isSpinner: false });
        }
      });
  }

  PlaiddSetupStatus(hid, id) {
    accountService
      .PlaiddSetupStatus(id, hid)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ plaidbtnStatus: "", plaidStatus: "" }, () => {
            this.setState({
              plaidbtnStatus: result.status,
              plaidStatus: result.isActive,
            });
          });
        }
      });
  }

  PlaiddSetupButtonPermission(hid) {
    accountService
      .GetRolePermission_Ach(hid)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            isPlaidSetupButton: result[0].isDACHReady === "Yes" ? true : false,
            enableDACH: result[0].isDACHEnable,
          });
        }
      });
  }

  onDrop = (files: any) => {
    if (files.length > 0) {
      if (
        files[0].path
          .substring(files[0].path.lastIndexOf(".") + 1, files[0].path.length)
          .toLowerCase() === "png" ||
        files[0].path
          .substring(files[0].path.lastIndexOf(".") + 1, files[0].path.length)
          .toLowerCase() === "jpg" ||
        files[0].path
          .substring(files[0].path.lastIndexOf(".") + 1, files[0].path.length)
          .toLowerCase() === "jpeg" ||
        files[0].path
          .substring(files[0].path.lastIndexOf(".") + 1, files[0].path.length)
          .toLowerCase() === "gif" ||
        files[0].path
          .substring(files[0].path.lastIndexOf(".") + 1, files[0].path.length)
          .toLowerCase() === "bmp"
      ) {
        let Previews = files.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        );
        this.setState({
          files: Previews,
          selectedFiles: Previews,
          isDiscardChanges: true,
        });
      } else {
        Utils.toastError(
          "Only JPG, JPEG, PNG, GIF, BMP filese can be uploaded in the Signature",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "bankDetailsSlideout",
          }
        );
      }
    }
  };

  saveBankDetails = () => {
    if (this.isFormValidate()) {
      if (this.state.actionType === "edit") {
        this.preSaveFunctionality();
      } else {
        if (this.state.activeTab !== "general") {
          this.preSaveFunctionality();
        } else {
          this.setState({ activeTab: "checking" });
        }
      }
    }
  };

  preSaveFunctionality() {
    let formData = { ...this.state.formData };
    if (this.state.isExistAcc) {
      formData.id = 0;
      formData.hotelID = this.state.hotelID;
    }
    if (formData.digitalSignaturelimit.length === 0) {
      formData.digitalSignaturelimit = 0;
    }

    if (
      this.state.lastActiveStatus === "Active" &&
      formData.status === "Inactive" &&
      formData.isrepeat === 1 &&
      this.state.actionType === "edit"
    ) {
      confirmAlert({
        title: "Inactivating confirmation",
        message:
          "Inactivating the account will stop all Recurring Transactions associated with this account. Would you like to continue?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.checkPrimaryAccount(formData),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      this.checkPrimaryAccount(formData);
    }
  }

  checkPrimaryAccount(formData: any) {
    if (formData.setDefault === "Yes") {
      this.isprimaryAccountExist(formData);
    } else {
      this.saveBankACDetails(formData);
    }
  }

  isprimaryAccountExist(formData: any) {
    let request: any = {};
    request.hotelID = formData.hotelID;
    request.oprID = formData.oprID;
    request.accttype = formData.acctType;
    accountService
      .IsPrimaryAccEXists(request)
      .then(async (result: any | null) => {
        if (result === "Yes") {
          confirmAlert({
            title: "Primary account confirmation",
            message:
              "A Primary Account already exists for this entity. Selecting this account as Primary will convert the other account to non-primary. Would you like to continue?",
            //NW19887//"There is already one primary account exist for this Property, making this as primary will make existing account to non-primary. Would you like to continue?",
            buttons: [
              {
                label: "Yes",
                onClick: () => this.saveBankACDetails(formData),
              },
              {
                label: "No",
                onClick: () => this.nonPrimaryACDetails(formData),
              },
            ],
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        } else {
          this.saveBankACDetails(formData);
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  nonPrimaryACDetails(formData: any) {
    formData.setDefault = "No";
    this.saveBankACDetails(formData);
  }

  saveBankACDetails(formData: any) {
    if(!this.state.isCustIDPresent) formData.isEPayEnable = -1;
    this.setState({ isSpinner: true, isButton: true });
    formData.obaccno = formData.obaccno.trim();
    accountService
      .SaveBankDetails(formData, this.state.selectedFiles)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
            let displayname = "";
            if (this.state.actionType === "new") {
              const acctTy = formData?.acctType?.toLowerCase() == "o" ? "OPR" : formData?.acctType?.toLowerCase() == "p" ? "PAY" : "MIS";
              displayname = formData.obaccno.substr(formData.obaccno.length - 3) + " - " + acctTy + " - " + formData.displayName.trim();
              this.setState({ isNewAccountAdded: true });
            }
            this.setState(
              {
                isSpinner: false,
                actionType: "edit",
                isDiscardChanges: false,
                isUpdatation: true,
                isButton: false,
                connectedAcctName: formData?.accountName,
                opdIDPlaid: Number(result.scheduleID),
                accDisplayNamePlaid: displayname
              },
              () => {
                let storage = JSON.parse(localStorage.getItem("storage")!);
                let tenantID = storage === null ? 0 : (storage.tenantID as any);
                let selectedExistAcc = { ...this.state.selectedExistAcc };
                selectedExistAcc.oprID = Number(result.scheduleID);
                selectedExistAcc.hotelID = this.state.hotelID;
                selectedExistAcc.tenantID = tenantID;
                selectedExistAcc.obaccno = "";
                this.bindFormData(selectedExistAcc);
                this.PlaidSetupDetails();
                if (this.state.formData.acctType !== "M") {
                  setTimeout(() => {
                    if (this.state.isShowSensitiveFields === "Yes") {
                      this.isPrintsamplecheck(Number(result.scheduleID));
                    }
                  }, 2000);
                } else {
                  this.props.hideSlideOut(1);
                }
              }
            );
          } else {
            this.setState({ isSpinner: false, isButton: false });
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false, isButton: false });
        reject();
      });
  }

  enbaleFundingSource = () => {
    let request: any = {};
    request.bankRefID = this.state.formData.id;
    request.hotelID = this.state.hotelID;
    accountService
      .EnableFundingSource(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.status === "Success") {
            this.PlaiddSetupStatus(this.state.hotelID, this.state.formData.id);
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  isPrintsamplecheck(oprID) {
    confirmAlert({
      title: "Print sample check",
      message:
        // "Changes have been made to this bank account information. Please print a sample check to confirm that all information is shown on the check as desired.  Use the Print Sample Check button to view the check layout. Do you wish to print sample?",
        "Changes have been made to the bank account. To confirm the check layout, please print a sample check. Do you need to print a sample?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.printSampleCheck(oprID),
        },
        {
          label: "No",
          onClick: () => { reject(); this.props.hideSlideOut(1) },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  isFundingSourceVerified() {
    confirmAlert({
      title: "Funding Source Exists",
      message:
        "Bank account already exists do you want to enable again?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.enbaleFundingSource(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  isFormValidate() {
    let errors = this.state.errors;
    let formData = { ...this.state.formData };
    let isForm = true;
    if (this.state.activeTab === "general") {
      if (formData.acctType === "") {
        errors.accountType = "Please select account type.";
        isForm = false;
      }
      if (formData.obaccno.trim() === "") {
        errors.txtAccount = "Please enter account number.";
        isForm = false;
      }
      if (formData.displayName.trim().length === 0) {
        errors.txtnickname = "Please enter nickname.";
        isForm = false;
      }
      if (formData.bankNo.trim().length === 0) {
        errors.txtbankCode = "Please enter bank code.";
        isForm = false;
      }

      if (formData.bankName.trim().length === 0) {
        errors.bankName = "Please enter bank name.";
        isForm = false;
      }

      if (
        formData.bankStreet.trim().length === 0 &&
        formData.bankCity.trim().length === 0
      ) {
        errors.bankStreetAddress1 = "Please enter address.";
        isForm = false;
      }

      if (formData.coa.trim().length === 0) {
        errors.coa = "Please enter COA.";
        isForm = false;
      } else if (formData.coa.trim().length !== 5) {
        errors.coa = "COA should be five digits.";
        isForm = false;
      }
      if (formData.accountName === null) {
        errors.accountName = "Please enter account name.";
        isForm = false;
      } else if (formData.accountName.trim().length === 0) {
        errors.accountName = "Please enter account name.";
        isForm = false;
      }

      if (formData.openingDate.trim().length === 0) {
        errors.openingDate = "Please enter opening date.";
        isForm = false;
      }
    } else {
      if (formData.routing.trim().length === 0) {
        errors.ABARoutingNo = "Please enter ABA routing number.";
        isForm = false;
      } else if (formData.routing.trim().length !== 9) {
        errors.ABARoutingNo = "ABA Routing Number must be nine digits number.";
        isForm = false;
      }
      if (formData.lastChkno.trim().length === 0) {
        errors.StartingCheckNo = "Please enter starting check number.";
        isForm = false;
      }
      if (formData.series.trim().length === 0) {
        errors.checkSeries = "Please enter check series.";
        isForm = false;
      }
      if (formData.cStreet.trim().length === 0) {
        errors.cStreet = "Please enter street.";
        isForm = false;
      }
      if (formData.cCity.trim().length === 0) {
        errors.cCity = "Please enter city.";
        isForm = false;
      }
      if (formData.cCountry.trim().length === 0) {
        errors.cCountry = "Please enter country.";
        isForm = false;
      }
      if (formData.cState.trim().length === 0) {
        errors.cState = "Please enter state.";
        isForm = false;
      }
      if (formData.cPostalCode.trim().length === 0) {
        errors.cPostalCode = "Please enter postal code.";
        isForm = false;
      }

      let addresslength =
        formData.cStreet.trim().length +
        formData.cCity.trim().length +
        formData.cCountry.trim().length +
        formData.cState.trim().length +
        formData.cPostalCode.trim().length;
      if (Number(addresslength) > 60) {
        Utils.toastError("Address on Check can not be more then 60 characters.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "bankDetailsSlideout",
        });
        isForm = false;
      }
      if (formData.payFileformatID === 5) {
        if (formData.companyCode.trim().length === 0) {
          errors.companyCode = "Please enter Company Code.";
          isForm = false;
        }
      }
    }
    this.setState({ errors });
    if (isForm === true) {
      return true;
    } else {
      return false;
    }
  }

  onDateSelect = (event: any) => {
    let formData = { ...this.state.formData };
    let errors = this.state.errors;
    let today = new Date(event);
    let dateNew =
      today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();
    formData.openingDate = dateNew;
    errors.openingDate = event.length === 0 ? "Please enter opening date." : "";
    formData.openingDate = dateNew;
    this.setState({ formData, errors, isDiscardChanges: true });
  };

  handleePayChange = (event) => {
    if (this.state.ePayFeatureStatus?.toLowerCase() === "yes") {
      const selected = event.target.checked ? 1 : 0;
      if (!event.target.checked) {
        let msg = "";
        if (this.state.isLastAccount)
          msg = "This is the only account with ePay enabled. Disabling ePay will remove the ePay option from any future payments. This will also change any existing invoices currently marked as ePay to use the “Check” payment method.";
        else
          msg = "Disabling ePay will prevent any future ePay payments from this account for the selected EHID";

        confirmAlert({
          title: "Alert",
          message: msg,
          buttons: [
            {
              label: "Confirm",
              onClick: () => { this.ePayYes(selected) },
            },
            {
              label: "Cancel",
              onClick: () => reject(),
            },
          ],
        });
      } else {
        this.ePayYes(selected)
      }
    }
  }

  ePayYes = (selected) => {
    let formData = { ...this.state.formData };
    let isEpayChange = false;
    if (this.state.epayToggleOldState !== selected)
      isEpayChange = true;
    formData.isEPayEnable = selected;
    formData.isEpayToggleChange = isEpayChange;
    this.setState({ formData, isDiscardChanges: true });
    console.log(formData)
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = this.state.errors;
    let formData = { ...this.state.formData };
    switch (name) {
      case "txtAccount":
        errors.txtAccount =
          value.trim().length === 0 ? "Please enter account number." : "";
        formData.obaccno = value;
        break;
      case "txtnickname":
        errors.txtnickname =
          value.trim().length === 0 ? "Please enter nickname." : "";
        if (value.trim().length <= 10) {
          formData.displayName = value;
        }
        break;
      case "txtbankCode":
        errors.txtbankCode =
          value.trim().length === 0 ? "Please enter bank code." : "";
        if (value.trim().length <= 12) {
          formData.bankNo = value;
        }
        break;
      case "bankName":
        errors.bankName =
          value.trim().length === 0 ? "Please enter bank name." : "";
        if (value.trim().length <= 40) {
          formData.bankName = value;
        }
        break;
      case "bankStreetAddress1":
        errors.bankStreetAddress1 =
          value.trim().length === 0 &&
            this.state.formData.bankCity.trim().length === 0
            ? "Please enter address."
            : "";

        if (value.trim().length <= 34) {
          formData.bankStreet = value;
        }
        break;
      case "bankStreetAddress2":
        errors.bankStreetAddress2 =
          value.trim().length === 0 &&
            this.state.formData.bankStreet.trim().length === 0
            ? "Please enter address."
            : "";
        if (value.trim().length <= 34) {
          formData.bankCity = value;
        }
        break;

      case "coa":
        errors.coa = value.trim().length === 0 ? "Please enter COA." : "";
        if (!isNaN(value)) {
          if (value.trim().length <= 5) {
            formData.coa = value.trim();
          }
        }
        break;
      case "accountName":
        errors.accountName =
          value.trim().length === 0 ? "Please enter account name." : "";
        if (value.trim().length <= 65) {
          formData.accountName = value;
        }
        break;

      case "openingDate":
        errors.openingDate =
          value.trim().length === 0 ? "Please enter opening date" : "";
        formData.openingDate = value;
        break;
      case "primary":
        formData.setDefault = event.target.checked ? "Yes" : "No";
        break;
      case "active":
        formData.status = event.target.checked ? "Active" : "Inactive";
        break;
      case "searchable":
        formData.searchable = event.target.checked ? "Yes" : "No";
        break;
      case "ABARoutingNo":
        errors.ABARoutingNo =
          value.trim().length === 0 ? "Please enter ABA routing number." : "";
        if (!isNaN(value)) {
          if (value.trim().length <= 9) {
            formData.routing = value.trim();
          }
        }
        break;
      case "StartingCheckNo":
        errors.StartingCheckNo =
          value.trim().length === 0
            ? "Please enter starting check number."
            : "";
        if (!isNaN(value)) {
          if (Number(value) <= 9000000) {
            formData.lastChkno = value;
          }
        }
        break;
      case "checkSeries":
        errors.checkSeries =
          value.trim().length === 0 ? "Check Series can not be blank." : "";
        if (value.trim().length <= 2) {
          formData.series = value;
        }
        break;
      case "cStreet":
        errors.cStreet =
          value.trim().length === 0 ? "Please enter street." : "";
        if (value.trim().length <= 50) {
          formData.cStreet = value;
        }
        break;
      case "cCity":
        errors.cCity = value.trim().length === 0 ? "Please enter city." : "";
        if (value.trim().length <= 50) {
          formData.cCity = value;
        }
        break;
      case "cCountry":
        errors.cCountry =
          value.trim().length === 0 ? "Please enter country." : "";
        if (value.trim().length <= 50) {
          formData.cCountry = value;
        }
        break;
      case "cState":
        errors.cState = value.trim().length === 0 ? "Please enter state." : "";
        if (value.trim().length <= 50) {
          formData.cState = value;
        }
        break;
      case "cPostalCode":
        errors.cPostalCode =
          value.trim().length === 0 ? "Please enter postal code." : "";
        if (value.trim().length <= 50) {
          formData.cPostalCode = value;
        }
        break;

      case "companyCode":
        errors.companyCode =
          value.trim().length === 0 ? "Please enter company code." : "";
        if (value.trim().length <= 45) {
          formData.companyCode = value;
        }
        break;
      case "digitalSignaturelimit":
        const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        if (rx_live.test(value)) {
          if (value.includes(".")) {
            const timeArray = value?.split(".");
            if (timeArray[0].length <= 6 && timeArray[1].length <= 2) {
              formData.digitalSignaturelimit = value;
            }
          } else {
            if (value.length <= 6) {
              formData.digitalSignaturelimit = value;
            }
          }
        } else if (value.includes(".") && value.length === 1) {
          formData.digitalSignaturelimit = value;
        }
        // if (!isNaN(value)) {
        //     if (value.trim().length <= 9) {
        //         formData.digitalSignaturelimit = value.trim();
        //     }
        // }
        break;
      default:
        break;
    }

    this.setState({ errors, formData, isDiscardChanges: true });
  };

  closeSlideout = () => {
    if (this.state.isDiscardChanges) {
      confirmAlert({
        title: "Unsaved confirmation",
        message:
          "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.pageClose(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      this.props.hideSlideOut(this.state.isUpdatation ? 1 : 0);
    }
  };

  pageClose() {
    this.props.hideSlideOut(this.state.isUpdatation ? 1 : 0);
  }

  onClickSignature = (event) => {
    if (event === "delete") {
      this.deleteSignature();
    } else if (event === "download") {
      this.downloadSignature();
    }
  };

  downloadSignature() {
    let request: any = {};
    request.oprID = this.state.formData.oprID;
    request.fileName = this.state.fileName;
    accountService
      .downloadSignature(request)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  deleteSignature() {
    let formData = { ...this.state.formData };
    accountService
      .Delete_AccountDigitalSign(formData)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            toast.success("Signature deleted successfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
            this.setState({ files: [], selectedFiles: [] });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  removeSelectedSignature = () => {
    this.setState({ files: [], selectedFiles: [] });
  };

  handleBankNotListed = () => {
    this.setState({ handleBankNotListedModal: true });
  };
  handleBankNotListedClose = () => {
    this.setState({ handleBankNotListedModal: false });
  };
  openOtpModal = () => {
    this.setState({ isOtpNeed: true });
  };
  closeOtpModal = () => {
    if (this.state.isOtpNeed) {
      this.setState({ isOtpNeed: false });
    }
  };

  isPermission() {
    if (this.state.formData.acctType !== "") {
      if (
        this.state.formData.acctType === "P" &&
        this.state.isEditPayroll === "Yes"
      ) {
        return false;
      } else if (
        this.state.formData.acctType === "O" &&
        this.state.isEditOperating === "Yes"
      ) {
        return false;
      } else if (
        this.state.formData.acctType === "M" &&
        this.state.isEditMisc === "Yes"
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  IsFielsDisabled() {
    if (this.state.actionType === "edit") {
      if (this.state.formData.owner === "Y") {
        return this.isPermission();
      } else {
        return true;
      }
    } else {
      if (this.state.isExistAcc) {
        return true;
      } else {
        return false;
      }
    }
  }

  handleDiscard() {
    this.props.hideSlideOut(0);
  }

  printSampleCheck = (oprID) => {
    let request: any = {};
    request.hotelID = this.state.hotelID;
    request.oprID = oprID;
    request.browserName = "chrome";
    accountService
      .PrintSampleCheck(request)
      .then(async (result: any | null) => {
        this.props.hideSlideOut(1);
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  downloadsign = () => {
    let BlobbaseUrl = this.state.BlobbaseUrl;
    //"https://innflowfilestoretest.blob.core.windows.net/innflowtemplate/SignatureForm.pdf?X=" + Math.floor(Math.random() * 100),
    fetch(BlobbaseUrl + "innflowtemplate/SignatureForm.pdf?X=" + Math.floor(Math.random() * 100),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      }
    )
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SignatureForm.pdf`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();
      });
  };

  ReSendOTP = () => {
    this.setupAuthentication(this.state.mode);
  };

  setupAuthentication = (mode) => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userName = storage === null ? 0 : (storage.userName as any);

    let request: any = {};
    request.userName = userName;
    request.otpCode = "";
    request.primaryContact = "Phone";
    if (mode === 3) {
      request.purpose = "Bank Validation Disable";
    } else {
      request.purpose = "Bank Validation";
    }

    accountService
      .OTPForAuthentication(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.status === "Success") {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });

            this.setState({ isOtpNeed: true, mode: mode });
          } else {
            toast.success("Something went wrong", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
          }
        }
      });
  };

  ValidateOTP = (OTPCode) => {
    this.setState({ otpSuccess: true, isOtpNeed: false }, () => {
      //this.plaidFunction(this.state.mode);
    });
    this.handleShowHideChoiceModal();
  };

  handleShowHideChoiceModal = () => {
    let isAlreadySetup = this.state.fundingSource;
    console.log(this.state.plaidbtnStatus);
    if (this.state.plaidbtnStatus === "VerifyMicro") {
      this.setState({ showVerifyModal: true });
    }
    else if (this.state.plaidbtnStatus === "disableACH") {
      this.plaidFunction();
    }
    else if (this.state.plaidbtnStatus === "reconnect") {
      this.plaidFunction();
    }
    else {
      if (isAlreadySetup !== "") {
        this.isFundingSourceVerified();
      }
      else {
        this.setState({ showChoiceModal: !this.state.showChoiceModal });
      }
    }
  };


  plaidFunction = () => {
    const { mode } = this.state;
    if (this.state.otpSuccess) {
      let msg = "";
      if (mode === 1) {
        if (this.state.plaidStatus.toString().toLowerCase() === "inactive") {
          PlaidSetup.saveFundingSourceHotel(
            this.state.hotelID,
            "inactive",
            this.state.formData.id
          );
          msg = "Funding source has been added successfully.";
        } else {
          PlaidSetup.IntegratePlaid(
            this.state.hotelID,
            this.state.formData.id,
            this.state.formData.accountName
          );
          msg = "Funding source has been added successfully.";
        }
      } else if (mode === 2) {
        PlaidSetup.ReconectHotelLinkToken(
          this.state.hotelID,
          this.state.formData.id
        );
        msg = "You account has been reconnected successfully.";
      } else if (mode === 3) {
        PlaidSetup.disabledACH(this.state.hotelID, this.state.formData.id);
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let tenantID = storage === null ? 0 : (storage.tenantID as any);
        let selectedExistAcc = { ...this.state.selectedExistAcc };
        selectedExistAcc.oprID = this.props.oprID;
        selectedExistAcc.hotelID = this.state.hotelID;
        selectedExistAcc.tenantID = tenantID;
        selectedExistAcc.obaccno = "";
        this.bindFormData(selectedExistAcc);
        msg = "Bank account has been disabled for Digital ACH successfully.";
      }
      const intervalId = setInterval(() => {
        let lblStatus = document.getElementById("lblSetupStatus");
        if (lblStatus?.innerHTML === "Success") {
          lblStatus.innerHTML = "";
          clearInterval(intervalId);
          toast.success(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "bankDetailsSlideout",
          });

          this.PlaiddSetupStatus(this.state.hotelID, this.state.formData.id);
        }
      }, 1000);
    } else {
      this.setState({ isOtpNeed: true });
    }
  }
  handleDatePicker = (event: any, refName: any) => {
    if (!this.IsFielsDisabled()) {
      this.setState({ calendarOpened: true });
    }
    refName.current.focus();
  };

  render() {
    const renderTooltip = (props) => {
      return (
        <Tooltip id="enableDACH-tooltip" {...props}>
          Adding a bank account as a Digital ACH funding source requires a
          Special Permission. Please contact your administrator to have this
          Special Permission assigned to you.
        </Tooltip>
      );
    };
    const renderhideTooltip = (props) => {
      return <div id="enableDACHhide-tooltip" {...props}></div>;
    };
    const files = this.state.files.map((file) => (
      <li className="d-flex align-items-center" key={file.name}>
        <div className="image-sec">
          <img src={file.preview} alt="" />
        </div>
        <div className="image-name mr-auto">
          {file.name} {file.uploaddatetime}
        </div>
        <div className="action delete">
          {this.state.files.length > 0 && this.state.selectedFiles.length > 0 && (
            <button
              type="button"
              className="btn wht-bg cross"
              onClick={() => {
                this.removeSelectedSignature();
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                  fill="#84888C"
                />
              </svg>
            </button>
          )}
          {this.state.files.length > 0 &&
            this.state.selectedFiles.length === 0 && (
              <Dropdown className="more-action" alignRight>
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {this.state.moreActionSignature.map((item: any, idx: any) => (
                    <>
                      {this.state.moreActionSignature[idx].eventKey ===
                        "delete" && (
                          <>
                            {this.state.formData.owner === "Y" && (
                              <Dropdown.Item
                                eventKey={
                                  this.state.moreActionSignature[idx].eventKey
                                }
                                key={idx}
                                onClick={() => {
                                  this.onClickSignature(
                                    this.state.moreActionSignature[idx].eventKey
                                  );
                                }}
                              >
                                {this.state.moreActionSignature[idx].name}
                              </Dropdown.Item>
                            )}
                          </>
                        )}
                      {/* {this.state.moreActionSignature[idx].eventKey === "download" && (
                                                <Dropdown.Item
                                                    eventKey={this.state.moreActionSignature[idx].eventKey}
                                                    key={idx}
                                                    onClick={() => { this.onClickSignature(this.state.moreActionSignature[idx].eventKey) }}
                                                >
                                                    {this.state.moreActionSignature[idx].name}
                                                </Dropdown.Item>
                                            )} */}
                    </>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
        </div>
      </li>
    ));
    const { errors } = this.state;
    const styles = {
      myElement: {
        display: "none",
      },
    };
    return (
      <div className="transaction-slideout bankAccount-setting pos-fxd index-1000">
        {/* <ToastContainer
          autoClose={3000}
          containerId={"bankDetailsSlideout"}
          enableMultiContainer
        /> */}
        <div className="d-flex">
          <div
            className="back-drop"
            onClick={() => {
              this.closeSlideout();
            }}
          ></div>
          <Container fluid className="body-sec">
            <div className="page-heading d-flex">
              {/* <div className="hid-set d-flex align-items-center">
                {this.state.hotelName}
              </div> */}
              <Dropdown className="hid-select">
                <Dropdown.Toggle
                  id="dropdown-hid"
                  disabled={this.state.isNewAccountAdded}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    {this.state.hotelName}
                    <div className="drop-arrow d-flex">
                      <FiChevronDown />
                    </div>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="cusEhidSelector">
                  <div className="EhidSearch">
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        type="text"
                        name="search"
                        value={this.state.search}
                        autoComplete="off"
                        onChange={this.searchItems}
                        placeholder="Filter EHIDs"
                      />
                    </Form.Group>
                  </div>
                  <div className="dropdownItems">
                    {this.state.hidList.length > 0 ? (
                      this.state.hidList.map(
                        (item: any, idx: number) => (
                          <React.Fragment key={idx}>
                            {(idx > 0
                              && item?.hotelType !== this.state.hidList[idx - 1]?.hotelType) && (
                                <Dropdown.Divider />

                              )}
                            <Dropdown.Item
                              eventKey={item.lettercode}
                              onClick={() => this.hotelChange(item)}
                            >
                              <div
                                className={
                                  item.lettercode === this.state.hotelName
                                    ? "dropDownListTitle hasCheck"
                                    : "dropDownListTitle"
                                }
                              >
                                <span className="name">
                                  {item.hotelName.split(" - ")[0]}
                                </span>
                                <span className="title">
                                  {
                                    item.hotelName
                                      .replace(" - ", ".")
                                      .split(".")[1]
                                  }
                                </span>
                                {item.lettercode === this.state.hotelName && (
                                  <span className="itemcheck">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.49998 11.6895L5.03023 9.21973L3.96973 10.2802L7.49998 13.8105L14.7802 6.53023L13.7197 5.46973L7.49998 11.6895Z"
                                        fill="#2CAF92"
                                      />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            </Dropdown.Item>
                            {/* {item.lettercode === "All" && <Dropdown.Divider />} */}
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Dropdown.Item>
                        <b>No Item Found</b>
                      </Dropdown.Item>
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              <div className="mr-auto d-flex align-items-center">
                {this.state.activeTab === "banksync" ? this.state.accDisplayNamePlaid : "Bank Account Settings"}
              </div>
              <div className="action-group d-flex">
                {this.state.digitalSign.toLowerCase() === "yes" && (
                  <button
                    type="button"
                    className="btn-outline-primary btn btn-primary"
                    onClick={this.downloadsign}
                  >
                    Digital Signature Form
                  </button>
                )}

                {this.state.isShowSensitiveFields === "Yes" &&
                  this.state.actionType === "edit" &&
                  this.state.formData.acctType !== "M" && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        this.printSampleCheck(this.state.formData.oprID);
                      }}
                    >
                      Print Sample Check
                    </button>
                  )}
                <button
                  type="button"
                  className="btn wht-bg cross"
                  onClick={() => {
                    this.closeSlideout();
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                      fill="#84888C"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="bank-account-setting">
              <Tabs
                id="bank-account-setting"
                activeKey={this.state.activeTab}
                onSelect={this.handleTabSelect}
              >
                <Tab eventKey="general" title="General">
                  <div className="section-ttl">Account Information</div>
                  <div
                    className={
                      this.state.isDiscardChanges
                        ? "form-section footer-enable"
                        : "form-section"
                    }
                    ref={this.parentScroll}
                  >
                    <Form.Group
                      as={Row}
                      className={
                        errors.accountType.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="accountType"
                    >
                      <Form.Label column sm="3">
                        Account Type
                      </Form.Label>
                      <Col sm="3">
                        <Dropdown className="custom-selectbox">
                          <Dropdown.Toggle
                            className="height-35"
                            id=""
                            name="accountType"
                            disabled={
                              this.state.actionType === "edit" ? true : false
                            }
                          >
                            <div
                              className={
                                this.state.selectedAccount?.id.length === 0
                                  ? "selected-value placeholder"
                                  : "selected-value"
                              }
                            >
                              {this.state.selectedAccount?.id.length === 0
                                ? "Select Account Type"
                                : this.state.selectedAccount?.name}
                            </div>
                            <svg
                              width="10"
                              height="7"
                              viewBox="0 0 10 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8.29272 0.292969L5.00006 3.5863L1.70739 0.292969L0.292725 1.70764L5.00006 6.4143L9.70739 1.70764L8.29272 0.292969Z" />
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="transform">
                            {this.state.accountType.map(
                              (item: any, idx: any) => (
                                <Dropdown.Item
                                  eventKey={item.id}
                                  key={idx}
                                  onClick={() => this.handleAccountSelect(item)}
                                >
                                  {" "}
                                  {item.name}{" "}
                                </Dropdown.Item>
                              )
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                        {errors.accountType.length > 0 && (
                          <span className="error">{errors.accountType}</span>
                        )}
                      </Col>
                    </Form.Group>
                    {this.state.selectedAccount?.id !== "M" && (
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="existingBankA/CNumber"
                      >
                        <Form.Label column sm="3">
                          Existing Bank A/C Number
                        </Form.Label>
                        <Col sm="3">
                          <Dropdown className="custom-selectbox">
                            <Dropdown.Toggle
                              className="height-35"
                              id=""
                              disabled={
                                this.state.actionType === "edit" ? true : false
                              }
                            >
                              <div
                                className={
                                  this.state.selectedExistAcc.obaccno === ""
                                    ? "selected-value placeholder"
                                    : "selected-value"
                                }
                              >
                                {this.state.selectedExistAcc.obaccno === ""
                                  ? "Select Existing Bank A/C Number"
                                  : this.state.selectedExistAcc.obaccno}
                              </div>
                              <svg
                                width="10"
                                height="7"
                                viewBox="0 0 10 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8.29272 0.292969L5.00006 3.5863L1.70739 0.292969L0.292725 1.70764L5.00006 6.4143L9.70739 1.70764L8.29272 0.292969Z" />
                              </svg>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="transform">
                              {this.state.existingBankAccount.map(
                                (item: any, idx: any) => (
                                  <Dropdown.Item
                                    eventKey={item.id}
                                    key={idx}
                                    onClick={() =>
                                      this.handleExistAccountSelect(item)
                                    }
                                  >
                                    {" "}
                                    {this.state.isShowSensitiveFields === "Yes"
                                      ? item.obaccno
                                      : item.obaccnored}{" "}
                                  </Dropdown.Item>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Form.Group>
                    )}
                    <Form.Group
                      as={Row}
                      className={
                        errors.txtAccount.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="txtAccount"
                    >
                      <Form.Label column sm="3">
                        Account Number
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Account Number"
                          autoComplete="off"
                          type="text"
                          id="txtAccount"
                          name="txtAccount"
                          value={
                            this.state.isShowSensitiveFields === "Yes"
                              ? this.state.formData.obaccno
                              : this.state.formData.accountNo
                          }
                          disabled={
                            this.state.actionType === "edit" &&
                              this.state.isShowSensitiveFields !== "Yes"
                              ? true
                              : this.IsFielsDisabled()
                          }
                          onChange={this.handleChange}
                        />
                        {errors.txtAccount.length > 0 && (
                          <span className="error">{errors.txtAccount}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.txtnickname.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="txtnickname"
                    >
                      <Form.Label column sm="3">
                        Nickname
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={
                            <Tooltip id={"tooltip-nickname"}>
                              This is used as the display name when selecting a
                              bank account on all pages.
                            </Tooltip>
                          }
                        >
                          <span>
                            <InfoTooltip />{" "}
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Nickname"
                          autoComplete="off"
                          type="text"
                          id="txtnickname"
                          name="txtnickname"
                          value={this.state.formData.displayName}
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.txtnickname.length > 0 && (
                          <span className="error">{errors.txtnickname}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.txtbankCode.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="txtbankCode"
                    >
                      <Form.Label column sm="3">
                        Bank Code
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Bank Code"
                          autoComplete="off"
                          type="text"
                          id="txtbankCode"
                          name="txtbankCode"
                          value={this.state.formData.bankNo}
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.txtbankCode.length > 0 && (
                          <span className="error">{errors.txtbankCode}</span>
                        )}
                      </Col>
                    </Form.Group>
                    {this.state.actionType === "edit" && (
                      <Form.Group
                        as={Row}
                        className={
                          errors.openingACBalance.length > 0
                            ? "mb-3 error"
                            : "mb-3"
                        }
                        controlId="openingA/CBalance"
                      >
                        <Form.Label column sm="3">
                          Opening Balance
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Tooltip id={"tooltip-openingA/CBalance"}>
                                {" "}
                                {
                                  "Opening balance cannot be entered from here. It can be entered from Accounting > Chart of Accounts > Opening Balances."
                                }
                              </Tooltip>
                            }
                          >
                            <span>
                              <InfoTooltip />{" "}
                            </span>
                          </OverlayTrigger>
                        </Form.Label>
                        <Col sm="3">
                          <Form.Control
                            placeholder="0"
                            autoComplete="off"
                            type="text"
                            id="openingA/CBalance"
                            name="openingACBalance"
                            value={this.state.formData.opnBal}
                            disabled={true}
                            onChange={this.handleChange}
                          />
                          {errors.openingACBalance.length > 0 && (
                            <span className="error">
                              {errors.openingACBalance}
                            </span>
                          )}
                        </Col>
                      </Form.Group>
                    )}
                    <Form.Group
                      as={Row}
                      className={
                        errors.bankName.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="bankName"
                    >
                      <Form.Label column sm="3">
                        Bank Name
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Bank Name"
                          autoComplete="off"
                          type="text"
                          id="bankName"
                          name="bankName"
                          value={this.state.formData.bankName}
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.bankName.length > 0 && (
                          <span className="error">{errors.bankName}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.bankStreetAddress1.length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="bankStreetAddress1"
                    >
                      <Form.Label column sm="3">
                        Bank Street Address 1
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Address Line 1"
                          autoComplete="off"
                          type="text"
                          id="bankStreetAddress1"
                          name="bankStreetAddress1"
                          value={this.state.formData.bankStreet}
                          onChange={this.handleChange}
                          disabled={this.IsFielsDisabled()}
                        />
                        {errors.bankStreetAddress1.length > 0 && (
                          <span className="error">
                            {errors.bankStreetAddress1}
                          </span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.bankStreetAddress2.length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="bankStreetAddress2"
                    >
                      <Form.Label column sm="3">
                        Bank Street Address 2
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Address Line 2"
                          autoComplete="off"
                          type="text"
                          id="bankStreetAddress2"
                          name="bankStreetAddress2"
                          value={this.state.formData.bankCity}
                          onChange={this.handleChange}
                          disabled={this.IsFielsDisabled()}
                        />
                        {errors.bankStreetAddress2.length > 0 && (
                          <span className="error">
                            {errors.bankStreetAddress2}
                          </span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={errors.coa.length > 0 ? "mb-3 error" : "mb-3"}
                      controlId="coa"
                    >
                      <Form.Label column sm="3">
                        COA
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={
                            <Tooltip id={"tooltip-openingA/CBalance"}>
                              {/* Please add new COA for the Account as COA number can not be selected from the existing COA's list */}
                              Each bank account must have its own chart of
                              account assigned.
                            </Tooltip>
                          }
                        >
                          <span>
                            <InfoTooltip />{" "}
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Col sm="3">
                        <Typeahead
                          key="id"
                          ref={this.coaRef}
                          id="coa"
                          inputProps={{
                            type: "number",
                          }}
                          onInputChange={(input) =>
                            this.onCOAInputChange(input, this.coaRef)
                          }
                          onKeyDown={this.keyDown}
                          disabled={this.IsFielsDisabled()}
                          options={this.state.coaList}
                          placeholder={"Enter COA"}
                          selected={this.state.selectedCOA}
                          onFocus={this.scrollToBottom}
                          renderMenu={(results: any, menuProps) => (
                            <Menu {...menuProps}>
                              {results.map((result: any, index: any) => (
                                <>
                                  {result.label !== "" && (
                                    <MenuItem option={result} position={index}>
                                      <EllipsisWithTooltip placement="bottom">
                                        {result.label}
                                      </EllipsisWithTooltip>
                                    </MenuItem>
                                  )}
                                  {result.label === "" && (
                                    <MenuItem
                                      className="load-more"
                                      option={result}
                                      position={index}
                                    >
                                      Load More
                                    </MenuItem>
                                  )}
                                </>
                              ))}
                            </Menu>
                          )}
                        />

                        {errors.coa.length > 0 && (
                          <span className="error">{errors.coa}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.accountName.trim().length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="accountName"
                    >
                      <Form.Label column sm="3">
                        Account Name
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={
                            <Tooltip id={"tooltip-openingA/CBalance"}>
                              {/* This name will appear on the checks */}
                              This name appears on the checks.
                            </Tooltip>
                          }
                        >
                          <span>
                            <InfoTooltip />{" "}
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Account Name"
                          autoComplete="off"
                          type="text"
                          id="accountName"
                          name="accountName"
                          value={this.state.formData.accountName}
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.accountName.trim().length > 0 && (
                          <span className="error">{errors.accountName}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="primaryAccount-custom-switch"
                    >
                      <Form.Label column sm="3">
                        Primary Account
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={
                            <Tooltip id={"tooltip-openingA/CBalance"}>
                              Each location must have one primary account.
                            </Tooltip>
                          }
                        >
                          <span>
                            <InfoTooltip />{" "}
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Col sm="3">
                        <Form.Check
                          type="switch"
                          id="primaryAccount"
                          label=""
                          name="primary"
                          disabled={this.isPermission()}
                          checked={
                            this.state.formData.setDefault === "Yes"
                              ? true
                              : false
                          }
                          onChange={this.handleChange}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group
                      as={Row}
                      className={
                        errors.openingDate.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="openingDatee"
                    >
                      <Form.Label column sm="3">
                        Opening Date
                      </Form.Label>
                      <Col sm="3">
                        <div className="calender-picker input-form-calender up-side-show">
                          <Form.Control
                            placeholder="Select Opening Date"
                            autoComplete="off"
                            type="text"
                            id="openingDate"
                            name="openingDate"
                            value={this.state.formData.openingDate}
                            ref={this.openingDateRef}
                            onClick={() => this.openCalendar()}
                          />
                          {this.state.calendarOpened ? (
                            <OutsideClickHandler
                              onOutsideClick={this.calenderHide}
                            >
                              <div className="calender">
                                <Calendar
                                  calendarType={"US"}
                                  onChange={this.changeDate}
                                  value={this.state.calenderSelectDate}
                                />
                              </div>
                            </OutsideClickHandler>
                          ) : null}
                          <span className="calender-icon">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0)">
                                <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                <g filter="url(#filter0_d)">
                                  <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                </g>
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d"
                                  x="-1.75"
                                  y="1.5"
                                  width="21.5"
                                  height="23"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  />
                                  <feOffset dy="4" />
                                  <feGaussianBlur stdDeviation="2" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow"
                                    result="shape"
                                  />
                                </filter>
                                <clipPath id="clip0">
                                  <rect width="18" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <span
                            className="chevron-down"
                            onClick={(event: any) =>
                              this.handleDatePicker(event, this.openingDateRef)
                            }
                          >
                            <FiChevronDown />
                          </span>
                        </div>
                        {errors.openingDate.length > 0 && (
                          <span className="error">{errors.openingDate}</span>
                        )}
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3" controlId="active">
                      <Form.Label column sm="3">
                        Active
                      </Form.Label>
                      <Col sm="3">
                        <Form.Check
                          type="switch"
                          id="activetgl"
                          label=""
                          name="active"
                          disabled={this.isPermission()}
                          checked={
                            this.state.formData.status === "Active"
                              ? true
                              : false
                          }
                          onChange={this.handleChange}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="searchable"
                    >
                      <Form.Label column sm="3">
                        Searchable
                      </Form.Label>
                      <Col sm="3">
                        <Form.Check
                          type="switch"
                          id="searchablectrl"
                          label=""
                          name="searchable"
                          disabled={
                            this.state.formData.acctType === "P"
                              ? true
                              : this.isPermission()
                          }
                          checked={
                            this.state.formData.searchable === "Yes"
                              ? true
                              : false
                          }
                          onChange={this.handleChange}
                        />
                      </Col>
                    </Form.Group>

                    {(this.state.formData?.acctType?.toLowerCase() === "o" || this.state.formData?.acctType?.toLowerCase() === "p")
                      && this.state.actionType === "edit"
                      && this.state.isCustIDPresent
                      && this.state.ePayFeatureStatus?.toLowerCase() === "yes" && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="primaryAccount-custom-switch"
                        >
                          <Form.Label column sm="3">
                            ePay
                          </Form.Label>
                          <Col sm="3">
                            <Form.Check
                              type="switch"
                              label=""
                              name="primary"
                              checked={
                                this.state.formData.isEPayEnable === 1
                                  ? true
                                  : false
                              }
                              onChange={this.handleePayChange}
                            />
                          </Col>
                        </Form.Group>
                      )
                    }
                    {/* {this.state.actionType === "edit" &&
                      this.state.isPlaidSetupButton &&
                      this.state.formData.status === "Active" &&
                      this.state.formData.owner === "Y" && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="digitalACH"
                        >
                          <Form.Label column sm="3">
                            Digital ACH
                          </Form.Label>
                          <Col sm="3">
                            <label id="lblSetupStatus" style={styles.myElement}>
                              Setup Status
                            </label>
                            <div className="d-flex align-items-center">
                              {this.state.plaidStatus != "" && (
                                <div style={{ paddingLeft: "8px" }}>
                                  {this.state.plaidStatus}
                                </div>
                              )}
                              <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                  this.state.enableDACH === "No"
                                    ? renderTooltip
                                    : renderhideTooltip
                                }
                              >
                                <div>
                                  {this.state.plaidbtnStatus === "setup" && (
                                    <button
                                      type="button"
                                      className={
                                        this.state.enableDACH === "No"
                                          ? "btn btn-primary height-35 btn-link form-padding disabled"
                                          : "btn btn-primary height-35 btn-link form-padding"
                                      }
                                      onClick={() => {
                                        this.setupAuthentication(1);
                                      }}
                                    >
                                      Setup
                                    </button>
                                  )}
                                  {this.state.plaidbtnStatus ===
                                    "reconnect" && (
                                      <button
                                        type="button"
                                        className={
                                          this.state.enableDACH === "No"
                                            ? "btn btn-primary height-35 btn-link form-padding disabled"
                                            : "btn btn-primary height-35 btn-link form-padding"
                                        }
                                        onClick={() => {
                                          this.setupAuthentication(2);
                                        }}
                                      >
                                        Reconnect Bank
                                      </button>
                                    )}
                                  {this.state.plaidbtnStatus ===
                                    "disableACH" && (
                                      <button
                                        type="button"
                                        className={
                                          this.state.enableDACH === "No"
                                            ? "btn btn-primary height-35 btn-link form-padding disabled"
                                            : "btn btn-primary height-35 btn-link form-padding"
                                        }
                                        onClick={() => {
                                          this.setupAuthentication(3);
                                        }}
                                      >
                                        Disable ACH
                                      </button>
                                    )}
                                  {this.state.plaidbtnStatus ===
                                    "VerifyMicro" && (
                                      <button
                                        type="button"
                                        className={
                                          this.state.enableDACH === "No"
                                            ? "btn btn-primary height-35 btn-link form-padding disabled"
                                            : "btn btn-primary height-35 btn-link form-padding"
                                        }
                                        onClick={() => {
                                          this.setupAuthentication(4);
                                        }}
                                      >
                                        Verify
                                      </button>
                                    )}
                                </div>
                              </OverlayTrigger>
                            </div>
                          </Col>
                        </Form.Group>
                      )} */}
                  </div>
                </Tab>
                <Tab eventKey="checking" title="Check">
                  <div className="section-ttl">Check Information</div>
                  <div
                    className={
                      this.state.isDiscardChanges
                        ? "form-section footer-enable"
                        : "form-section"
                    }
                  >
                    <Form.Group
                      as={Row}
                      className={
                        errors.ABARoutingNo.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="ABARoutingNo."
                    >
                      <Form.Label column sm="3">
                        ABA Routing No.
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter ABA Routing No."
                          type="text"
                          id="ABARoutingNo"
                          name="ABARoutingNo"
                          value={this.state.formData.routing}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.ABARoutingNo.length > 0 && (
                          <span className="error">{errors.ABARoutingNo}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.StartingCheckNo.length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="StartingCheckNo."
                    >
                      <Form.Label column sm="3">
                        Starting Check No.
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Starting Check No."
                          type="text"
                          id="StartingCheckNo."
                          name="StartingCheckNo"
                          value={this.state.formData.lastChkno}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.StartingCheckNo.length > 0 && (
                          <span className="error">
                            {errors.StartingCheckNo}
                          </span>
                        )}
                      </Col>
                    </Form.Group>

                    <Form.Group
                      as={Row}
                      className={
                        errors.checkSeries.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="checkSeries"
                    >
                      <Form.Label column sm="3">
                        Check Series
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={
                            <Tooltip id={"tooltip-checkSeries"}>
                              Changing the Check Series will restart the check
                              numbers. If adding a new bank account, set the
                              Check Series to A.
                            </Tooltip>
                          }
                        >
                          <span>
                            <InfoTooltip />{" "}
                          </span>
                        </OverlayTrigger>
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Check Series"
                          type="text"
                          id="checkSeries."
                          name="checkSeries"
                          value={this.state.formData.series}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.checkSeries.length > 0 && (
                          <span className="error">{errors.checkSeries}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.cStreet.length > 0 ? "mb-3 error" : "mb-3"
                      }
                      controlId="cStreet"
                    >
                      <Form.Label column sm="3">
                        Street
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Street"
                          type="text"
                          id="cStreet"
                          name="cStreet"
                          value={this.state.formData.cStreet}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.cStreet.length > 0 && (
                          <span className="error">{errors.cStreet}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.cCity.length > 0 || errors.cState.length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="cCity"
                    >
                      <Form.Label column sm="3">
                        City / State{" "}
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter City"
                          type="text"
                          id="cCity"
                          name="cCity"
                          value={this.state.formData.cCity}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.cCity.length > 0 && (
                          <span className="error">{errors.cCity}</span>
                        )}
                      </Col>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter State"
                          type="text"
                          id="cState"
                          name="cState"
                          value={this.state.formData.cState}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.cState.length > 0 && (
                          <span className="error">{errors.cState}</span>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className={
                        errors.cPostalCode.length > 0 ||
                          errors.cCountry.length > 0
                          ? "mb-3 error"
                          : "mb-3"
                      }
                      controlId="cPostalCode"
                    >
                      <Form.Label column sm="3">
                        Zip Code / Country
                      </Form.Label>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Zip Code"
                          type="text"
                          id="cPostalCode"
                          name="cPostalCode"
                          value={this.state.formData.cPostalCode}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.cPostalCode.length > 0 && (
                          <span className="error">{errors.cPostalCode}</span>
                        )}
                      </Col>
                      <Col sm="3">
                        <Form.Control
                          placeholder="Enter Country"
                          type="text"
                          id="cCountry"
                          name="cCountry"
                          value={this.state.formData.cCountry}
                          autoComplete="off"
                          disabled={this.IsFielsDisabled()}
                          onChange={this.handleChange}
                        />
                        {errors.cCountry.length > 0 && (
                          <span className="error">{errors.cCountry}</span>
                        )}
                      </Col>
                    </Form.Group>
                    {this.state.formData.acctType !== "M" && (
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="positivePayFormate"
                      >
                        <Form.Label column sm="3">
                          Positive Pay Format
                        </Form.Label>
                        <Col sm="3">
                          {/* <Dropdown className="custom-selectbox">
                            <Dropdown.Toggle
                              className="height-35"
                              id=""
                              disabled={this.IsFielsDisabled()}
                            >
                              <div
                                className={
                                  this.state.formData.payFileformatID === -1
                                    ? "selected-value placeholder"
                                    : "selected-value"
                                }
                              >
                                {this.state.formData.payFileformatID === -1
                                  ? "Select Positive Pay Format"
                                  : this.state.formData.payFileformatName}
                              </div>
                              <svg
                                width="10"
                                height="7"
                                viewBox="0 0 10 7"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8.29272 0.292969L5.00006 3.5863L1.70739 0.292969L0.292725 1.70764L5.00006 6.4143L9.70739 1.70764L8.29272 0.292969Z" />
                              </svg>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="transform">
                              {this.state.payFileformatList.map(
                                (item: any, idx: any) => (
                                  <Dropdown.Item
                                    eventKey={item.id}
                                    key={idx}
                                    onClick={() =>
                                      this.handlePayFormatSelect(item)
                                    }
                                  >
                                    {" "}
                                    {item.payFileFormat}{" "}
                                  </Dropdown.Item>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown> */}
                          <Typeahead
                            id="paylistid"
                            //onChange={(e) => this.handlePayFormatSelect(e)}
                            onInputChange={input => this.handleTypeaheadInput(input)}  
                            onChange={this.handleSelectedItem.bind(this)}
                            options={this.state.payFileformatList}
                            disabled={this.IsFielsDisabled()}
                            onBlur={this.handleTypeaheadBlur}
                            placeholder="Enter Positive Pay format"
                            selected={this.state.selectedPayFormat}
                            renderMenu={(results: any, menuProps) => (
                              <Menu {...menuProps} className="menu-item-clickable">
                                {results.map((result: any, index: any) => (
                                  <MenuItem option={result} position={index} >
                                    <EllipsisWithTooltip placement="bottom">
                                      {result.label}
                                    </EllipsisWithTooltip>
                                  </MenuItem>
                                ))}
                              </Menu>
                            )}
                          />
                        </Col>
                        <Col>
                          <Button
                            variant="primary"
                            className="btn-link"
                            onClick={this.handleBankNotListed}
                          >
                            Is your bank not listed?{" "}
                          </Button>
                        </Col>
                      </Form.Group>
                    )}
                    {this.state.formData.payFileformatID === 5 &&
                      this.state.formData.acctType !== "M" && (
                        <Form.Group
                          as={Row}
                          className={
                            errors.companyCode.length > 0
                              ? "mb-3 error"
                              : "mb-3"
                          }
                          controlId="cPostalCode"
                        >
                          <Form.Label column sm="3">
                            Company Code
                          </Form.Label>
                          <Col sm="3">
                            <Form.Control
                              placeholder="Enter Company Code"
                              type="text"
                              id="companyCode"
                              name="companyCode"
                              value={this.state.formData.companyCode}
                              autoComplete="off"
                              disabled={this.IsFielsDisabled()}
                              onChange={this.handleChange}
                            />
                            {errors.companyCode.length > 0 && (
                              <span className="error">
                                {errors.companyCode}
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      )}
                    {this.state.formData.acctType !== "M" &&
                      this.state.digitalSign.toLowerCase() === "yes" && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="digitalSignaturelimit"
                        >
                          <Form.Label column sm="3">
                            Digital Signature Limit
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip id={"tooltip-digitalSignature"}>
                                  Adding a limit will print a signature on all
                                  checks below this amount. If no limit is
                                  added, no signature will print.
                                </Tooltip>
                              }
                            >
                              <span>
                                <InfoTooltip />{" "}
                              </span>
                            </OverlayTrigger>
                          </Form.Label>
                          <Col sm="3">
                            <Form.Control
                              placeholder="Enter Limit"
                              autoComplete="off"
                              type="text"
                              id="digitalSignaturelimit."
                              name="digitalSignaturelimit"
                              value={this.state.formData.digitalSignaturelimit}
                              disabled={this.IsFielsDisabled()}
                              onChange={this.handleChange}
                            />
                          </Col>
                        </Form.Group>
                      )}
                    {this.state.formData.acctType !== "M" &&
                      this.state.digitalSign.toLowerCase() === "yes" && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="uploadDigitalSignature"
                        >
                          <Form.Label column sm="12">
                            Upload Digital Signature
                          </Form.Label>
                          <Col sm="6">
                            <Dropzone
                              onDrop={this.onDrop}
                              multiple={false}
                              disabled={this.IsFielsDisabled()}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="upload-link">
                                  <div
                                    {...getRootProps({
                                      className:
                                        "dropzone d-flex justify-content-center align-items-center",
                                    })}
                                  >
                                    <input {...getInputProps()} />
                                    {this.state.files.length < 1 && (
                                      <p>
                                        Drag and drop Document or{" "}
                                        <span>browse files</span> to upload.
                                      </p>
                                    )}
                                  </div>
                                  <aside>
                                    <ul>{files}</ul>
                                  </aside>
                                </div>
                              )}
                            </Dropzone>
                          </Col>
                        </Form.Group>
                      )}
                  </div>
                </Tab>
                {/* {this.state.bankSyncPerm && this.state.isBankSyncFeatureFlag && this.state.actionTypeBankSync === "edit" && this.state.formData.status?.toString().toLowerCase() === "active" && (
                  <Tab eventKey="banksync" title="Bank Sync" disabled={this.state.actionType === "new"}>
                    <div className="BankSyncTab">
                      <div className="body-section">
                        <div className="form-section-banksync align-item-center d-flex flex-column">
                          <Form.Group className="d-flex align-item-center" controlId="bankSyncToggle">
                            <Form.Label className="toggleLabelB">
                              Bank Sync
                            </Form.Label>
                            <Form.Check
                              type="switch"
                              id="banksync"
                              label=""
                              className="bankSyncToggle"
                              checked={this.state.bankSyncOn}
                              onChange={(e: any) => { this.changeBankSyncOn(e.currentTarget.checked) }}
                            />
                          </Form.Group>
                        </div>

                        <div className="bank-tab">
                          <div className="body-section-bank-sync">
                            {!this.state.bankSyncOn && !this.state.isSpinner && (
                              <>
                                <div className="circleBankSection d-flex align-items-center justify-content-center">
                                  <div className="circle-BankFeed d-flex align-items-center justify-content-center">
                                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_1314_21405)">
                                        <path d="M49.9999 99.9998C77.6141 99.9998 99.9998 77.6141 99.9998 49.9999C99.9998 22.3857 77.6141 0 49.9999 0C22.3857 0 0 22.3857 0 49.9999C0 77.6141 22.3857 99.9998 49.9999 99.9998Z" fill="#F4F8FB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7832 55.3916H50.0175L36.9004 48.1396L23.7832 55.3916Z" fill="#E4E8EB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.8553 64.5416C29.8553 61.8934 29.9568 59.3787 30.1389 57.1143H26.5487C26.7309 59.3788 26.8323 61.8934 26.8323 64.5416C26.8323 67.4348 26.7113 70.1688 26.4961 72.5911H30.1916C29.9763 70.1688 29.8553 67.435 29.8553 64.5416ZM46.9037 64.5416C46.9037 61.8934 47.0051 59.3787 47.1873 57.1143H43.597C43.7793 59.3788 43.8806 61.8934 43.8806 64.5416C43.8806 67.4348 43.7596 70.1688 43.5444 72.5911H47.2399C47.0248 70.1688 46.9037 67.435 46.9037 64.5416ZM38.3795 64.5417C38.3795 61.8935 38.481 59.3788 38.6631 57.1144H35.0729C35.255 59.3789 35.3565 61.8935 35.3565 64.5417C35.3565 67.435 35.2355 70.1689 35.0202 72.5912H38.7157C38.5005 70.1688 38.3795 67.435 38.3795 64.5417Z" fill="#E4E8EB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M51.0684 57.8788C51.5048 57.8788 51.8607 57.5229 51.8607 57.0865V55.5433C51.8607 55.1069 51.5048 54.751 51.0684 54.751H22.6673C22.2309 54.751 21.875 55.1069 21.875 55.5433V57.0865C21.875 57.5229 22.2309 57.8788 22.6673 57.8788H51.0684ZM25.8185 71.8272H47.9173C48.4209 71.8272 48.8315 72.2378 48.8315 72.7414V75.0633C48.8315 75.5669 48.4208 75.9775 47.9173 75.9775H25.8185C25.3149 75.9775 24.9043 75.5669 24.9043 75.0633V72.7414C24.9042 72.2379 25.3149 71.8272 25.8185 71.8272Z" fill="#CAD0D7" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7892 78.1257H50.9465C51.4501 78.1257 51.8607 77.7151 51.8607 77.2116V75.8907C51.8607 75.3872 51.4501 74.9766 50.9465 74.9766H22.7892C22.2856 74.9766 21.875 75.3872 21.875 75.8907V77.2116C21.875 77.715 22.2856 78.1257 22.7892 78.1257Z" fill="#A9B0BB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M50.0474 29.1269H76.2817L63.1645 21.875L50.0474 29.1269Z" fill="#CAD0D7" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M56.1191 38.277C56.1191 35.6287 56.2205 33.114 56.4027 30.8496H52.8125C52.9947 33.1141 53.0961 35.6287 53.0961 38.277C53.0961 41.1702 52.975 43.9042 52.7598 46.3264H56.4553C56.2401 43.9042 56.1191 41.1702 56.1191 38.277ZM73.1675 38.277C73.1675 35.6287 73.2689 33.114 73.4511 30.8496H69.8609C70.0432 33.1141 70.1445 35.6287 70.1445 38.277C70.1445 41.1702 70.0235 43.9042 69.8083 46.3264H73.5038C73.2886 43.9042 73.1675 41.1702 73.1675 38.277ZM64.6433 38.2771C64.6433 35.6289 64.7448 33.1141 64.9269 30.8497H61.3367C61.5189 33.1143 61.6203 35.6289 61.6203 38.2771C61.6203 41.1703 61.4993 43.9043 61.2841 46.3266H64.9796C64.7643 43.9042 64.6433 41.1703 64.6433 38.2771Z" fill="#CAD0D7" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M77.3326 31.6143C77.769 31.6143 78.1249 31.2584 78.1249 30.822V29.2786C78.1249 28.8422 77.769 28.4863 77.3326 28.4863H48.9315C48.4951 28.4863 48.1392 28.8422 48.1392 29.2786V30.8219C48.1392 31.2583 48.4951 31.6142 48.9315 31.6142H77.3326V31.6143ZM52.0826 45.5627H74.1815C74.6849 45.5627 75.0957 45.9733 75.0957 46.4768V48.7988C75.0957 49.3023 74.6849 49.713 74.1815 49.713H52.0826C51.5791 49.713 51.1685 49.3023 51.1685 48.7988V46.4768C51.1685 45.9733 51.5791 45.5627 52.0826 45.5627Z" fill="#A9B0BB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M49.0533 51.8611H77.2107C77.7142 51.8611 78.1249 51.4505 78.1249 50.9469V49.6261C78.1249 49.1225 77.7142 48.7119 77.2107 48.7119H49.0533C48.5498 48.7119 48.1392 49.1225 48.1392 49.6261V50.9469C48.1392 51.4504 48.5499 51.8611 49.0533 51.8611Z" fill="#636C77" />
                                        <path d="M56.1201 56.1265C59.5037 52.7429 59.5037 47.2571 56.1201 43.8735C52.7366 40.49 47.2507 40.49 43.8672 43.8735C40.4836 47.2571 40.4836 52.7429 43.8672 56.1265C47.2507 59.51 52.7366 59.51 56.1201 56.1265Z" fill="#FDCD56" />
                                        <path d="M55.1719 55.1782C58.0317 52.3184 58.0317 47.6816 55.1719 44.8218C52.312 41.9619 47.6753 41.9619 44.8154 44.8218C41.9556 47.6816 41.9556 52.3184 44.8154 55.1782C47.6753 58.0381 52.312 58.0381 55.1719 55.1782Z" fill="#F5B945" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M50.0026 49.215C49.2803 49.215 48.6902 48.7297 48.6902 48.1322C48.6902 47.5356 49.2803 47.0504 50.0026 47.0504C50.3721 47.0504 51.0779 47.3704 51.2047 47.5589C51.4528 47.9387 51.9657 48.0442 52.3406 47.7946C52.7211 47.546 52.8259 47.0374 52.5777 46.659C52.2137 46.1047 51.4693 45.7217 50.8076 45.5364L50.7966 45.0371C50.7855 44.5919 50.4216 44.2368 49.975 44.2368C49.9695 44.2368 49.9639 44.2368 49.9584 44.2368C49.5007 44.2484 49.1423 44.6235 49.1534 45.0769L49.1644 45.521C47.9457 45.854 47.0469 46.8981 47.0469 48.1321C47.0469 49.6343 48.3758 50.8554 50.0026 50.8554C50.725 50.8554 51.3095 51.3404 51.3095 51.9372C51.3095 52.5347 50.725 53.02 50.0026 53.02C49.4953 53.02 49.2526 52.8712 48.784 52.4257C48.4532 52.1153 47.9347 52.1294 47.6204 52.4597C47.3116 52.7891 47.3282 53.3083 47.6535 53.6188C48.067 54.0079 48.5248 54.3897 49.1974 54.5633L49.2029 54.9629C49.2139 55.4095 49.5834 55.7635 50.0245 55.7635H50.0466C50.4988 55.7516 50.8571 55.3765 50.8461 54.9231L50.8351 54.5492C52.0593 54.2153 52.9526 53.171 52.9526 51.9372C52.9528 50.4359 51.6294 49.215 50.0026 49.215ZM74.2765 46.4762C74.2765 46.4258 74.2324 46.3825 74.1827 46.3825H58.7703C58.9689 46.8665 59.1288 47.3717 59.2501 47.8907H74.2765V46.4762ZM77.2102 49.5312H59.4762C59.4817 49.6872 59.4872 49.843 59.4872 50.0002C59.4872 50.3517 59.4652 50.6985 59.4265 51.0408H77.21C77.2652 51.0408 77.3038 50.9973 77.3038 50.9471V49.6262C77.3039 49.5748 77.2652 49.5312 77.2102 49.5312ZM57.844 50.0002C57.844 54.3255 54.3259 57.8447 50.0026 57.8447C45.6739 57.8447 42.1559 54.3255 42.1559 50.0002C42.1559 45.6747 45.6739 42.1556 50.0026 42.1556C54.3259 42.1556 57.844 45.6747 57.844 50.0002ZM46.082 64.542C46.082 62.5426 46.1427 60.5857 46.253 58.7129C46.242 58.7083 46.2309 58.7037 46.2199 58.6989H44.5325C44.6428 60.574 44.7035 62.5343 44.7035 64.5419C44.7035 66.7753 44.6318 68.9458 44.494 71.0058H46.2916C46.1537 68.9459 46.082 66.7755 46.082 64.542ZM48.012 72.7403C48.012 72.6899 47.9679 72.6465 47.9182 72.6465H25.817C25.7673 72.6465 25.7232 72.6899 25.7232 72.7403V74.1559H48.012V72.7403ZM50.9456 75.7964H22.7897C22.74 75.7964 22.6959 75.8386 22.6959 75.8904V77.211C22.6959 77.2614 22.74 77.3047 22.7897 77.3047H50.9456C50.9952 77.3047 51.0394 77.2615 51.0394 77.211V75.8904C51.0394 75.8387 50.9952 75.7964 50.9456 75.7964ZM27.4823 58.6989C27.5926 60.574 27.6533 62.5343 27.6533 64.5419C27.6533 66.7753 27.5816 68.9458 27.4438 71.0058H29.247C29.1035 68.9456 29.0374 66.7753 29.0374 64.5419C29.0374 62.5343 29.0926 60.574 29.2084 58.6989H27.4823ZM36.1784 64.542C36.1784 66.7755 36.1066 68.9459 35.9688 71.0059H37.772C37.6286 68.9458 37.5625 66.7755 37.5625 64.542C37.5625 62.5368 37.6175 60.5751 37.7334 58.699H36.0075C36.1177 60.574 36.1784 62.5344 36.1784 64.542ZM34.32 71.0059C34.4633 68.9493 34.535 66.7791 34.535 64.542C34.535 62.5321 34.48 60.5717 34.3641 58.699H30.8516C30.7358 60.5718 30.6751 62.5321 30.6751 64.542C30.6751 66.7791 30.7468 68.9493 30.8902 71.0059H34.32ZM42.8892 58.6989H39.3711C39.2609 60.5726 39.2002 62.5343 39.2002 64.5419C39.2002 66.779 39.2719 68.9492 39.4152 71.0058H42.845C42.9884 68.9492 43.0601 66.779 43.0601 64.5419C43.0602 62.5321 43.0051 60.5717 42.8892 58.6989ZM22.6959 57.0583H43.6723C43.176 56.6107 42.7238 56.1127 42.3323 55.5712H22.6959V57.0583ZM28.122 53.9306H41.3728C40.9703 53.0529 40.7 52.1059 40.5843 51.1124L36.9007 49.0769L28.122 53.9306ZM53.9177 38.2767C53.9177 39.3055 53.9012 40.3344 53.8737 41.3434C54.3975 41.5801 54.9048 41.8638 55.3736 42.1895C55.324 40.9111 55.3018 39.6021 55.3018 38.2767C55.3018 36.2715 55.3569 34.311 55.4728 32.4338H53.7469C53.8627 34.311 53.9177 36.2715 53.9177 38.2767ZM48.9605 30.793H77.3039V29.3059H48.9605V30.793ZM54.3865 27.6654H71.944L63.1652 22.8128L54.3865 27.6654ZM70.9679 38.2767C70.9679 40.5115 70.8962 42.6806 70.7529 44.7419H72.556C72.4182 42.6817 72.3465 40.5115 72.3465 38.2767C72.3465 36.2715 72.4072 34.3099 72.5175 32.4338H70.7971C70.9073 34.3099 70.9679 36.2715 70.9679 38.2767ZM69.1097 44.7419C69.253 42.6853 69.3247 40.5149 69.3247 38.2767C69.3247 36.2692 69.2696 34.3076 69.1537 32.4338H65.6357C65.5254 34.3076 65.4647 36.2692 65.4647 38.2767C65.4647 40.515 65.5364 42.6853 65.6797 44.7419H69.1097ZM62.4429 38.2767C62.4429 40.5115 62.3712 42.6817 62.2334 44.7419H64.0365C63.8932 42.6817 63.8215 40.5115 63.8215 38.2767C63.8215 36.2715 63.8822 34.311 63.9925 32.4338H62.272C62.3822 34.311 62.4429 36.2715 62.4429 38.2767ZM57.888 44.7419H60.5845C60.7278 42.6853 60.7996 40.5149 60.7996 38.2767C60.7996 36.2692 60.7445 34.3076 60.6286 32.4338H57.116C57.0002 34.3076 56.9395 36.2692 56.9395 38.2767C56.9395 40.1329 56.9892 41.9575 57.0885 43.7072C57.3807 44.0329 57.6455 44.3787 57.888 44.7419ZM73.9897 38.2767C73.9897 40.5161 74.0614 42.6865 74.2048 44.7431C75.1477 44.7547 75.9142 45.5272 75.9142 46.4762V47.8908H77.21C78.1696 47.8908 78.947 48.6688 78.947 49.6263V50.9472C78.947 51.9034 78.1694 52.6814 77.21 52.6814H59.0958C57.9377 56.6097 54.2984 59.4853 50.0027 59.4853C49.2694 59.4853 48.5524 59.3998 47.8687 59.2404C47.775 60.9503 47.7254 62.7279 47.7254 64.5421C47.7254 66.7792 47.7971 68.9507 47.9405 71.0073C48.8834 71.0189 49.6499 71.7912 49.6499 72.7404V74.156H50.9457C51.9053 74.156 52.6827 74.934 52.6827 75.8904V77.211C52.6827 78.1674 51.9052 78.9455 50.9457 78.9455H22.7897C21.8357 78.9455 21.0527 78.1675 21.0527 77.211V75.8904C21.0527 74.934 21.8358 74.156 22.7897 74.156H24.0855V72.7404C24.0855 71.7924 24.8521 71.0189 25.795 71.0073C25.9383 68.9507 26.01 66.7792 26.01 64.5421C26.01 62.5322 25.9548 60.5718 25.839 58.6991H22.6684C21.7806 58.6991 21.0527 57.9749 21.0527 57.0866V55.5433C21.0527 54.6539 21.7806 53.9308 22.6684 53.9308H24.7308L36.5038 47.4222C36.752 47.2849 37.0496 47.2849 37.2978 47.4222L40.5513 49.2197C40.9484 44.3529 45.0345 40.515 50.0028 40.515C50.7749 40.515 51.5248 40.6101 52.2471 40.7858C52.2636 39.9562 52.2746 39.117 52.2746 38.2769C52.2746 36.2693 52.2196 34.3077 52.1037 32.4339H48.9329C48.0451 32.4339 47.3228 31.7108 47.3228 30.8214V29.278C47.3228 28.3897 48.0451 27.6655 48.9329 27.6655H50.9953L62.7682 21.1568C63.0163 21.0206 63.3141 21.0206 63.5623 21.1568L75.3353 27.6653H77.3314C78.2248 27.6653 78.9471 28.3895 78.9471 29.2778V30.8212C78.9471 31.7106 78.2248 32.4337 77.3314 32.4337H74.1607C74.0449 34.3075 73.9897 36.2692 73.9897 38.2767ZM71.3926 58.542C71.2382 58.3883 71.0286 58.3019 70.8081 58.3019C70.593 58.3019 70.3835 58.3885 70.2291 58.542L66.7495 62.0211C66.4297 62.3424 66.4297 62.8614 66.7495 63.1813C67.0693 63.5024 67.5877 63.5024 67.9131 63.1813L69.992 61.1024V66.3663C69.992 68.2345 68.4701 69.7531 66.6062 69.7531H60.2759C59.8181 69.7531 59.4543 70.1199 59.4543 70.5735C59.4543 71.0258 59.8182 71.3937 60.2759 71.3937H66.6062C69.3744 71.3937 71.6297 69.1391 71.6297 66.3662V61.1024L73.7086 63.1813C74.0284 63.5024 74.5522 63.5024 74.8721 63.1813C75.192 62.8614 75.192 62.3424 74.8721 62.0211L71.3926 58.542ZM25.1333 37.9791L28.6129 41.4585C28.7728 41.6189 28.9823 41.6986 29.1919 41.6986C29.4014 41.6986 29.6109 41.6189 29.7709 41.4585L33.2504 37.9791C33.5702 37.658 33.5702 37.1388 33.2504 36.8189C32.9306 36.4978 32.4123 36.4978 32.0924 36.8189L30.0135 38.8978V33.6338C30.0135 31.7658 31.5299 30.2471 33.3993 30.2471H39.7296C40.1818 30.2471 40.5457 29.8803 40.5457 29.4269C40.5457 28.9745 40.1817 28.6063 39.7296 28.6063H33.3991C30.6254 28.6063 28.3702 30.8612 28.3702 33.6338V38.8978L26.2912 36.8189C25.9714 36.4978 25.4531 36.4978 25.1332 36.8189C24.8134 37.1387 24.8134 37.6579 25.1333 37.9791Z" fill="black" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1314_21405">
                                          <rect width="100" height="100" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>

                                  </div>
                                </div>
                                <div className="labelBankS">Bank Sync</div>
                                <div className="infoText">
                                  When enabled, Bank Sync automatically imports transactions from your connected bank account and finds matches with Inn-Flow transactions.
                                  This makes keeping up with your daily accounting easy and makes reconciliation a snap.
                                </div>
                                <div className="btn-BankSync">
                                  <Button
                                    variant="primary"
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.changeBankSyncOn(true)}
                                  >
                                    Enable Bank Sync
                                  </Button>
                                </div>
                              </>
                            )}
                            {this.state.bankSyncOn && (
                              <SetupBankSync
                                parentState={this.state}
                                handleCancelSetup={this.handleCancelSetup}
                                callBackBankSetup={this.callBackBankSetup}
                                OprID={this.props.oprID}
                                accountName={this.state?.connectedAcctName}
                                callFrom={this.props?.callFrom}
                                closeSlideoutReconnect={this.closeSlideoutReconnect}
                                bankNickName={this.state.formData.displayName}
                              ></SetupBankSync>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                )} */}
              </Tabs>
              {this.state.isDiscardChanges && (
                <div className="footer-section d-flex justify-content-end align-items-center">
                  {this.state.isDiscardChanges && (
                    <Button
                      variant="primary"
                      type="button"
                      className="space btn btn-primary btn-discard"
                      onClick={() => this.handleDiscard()}
                    >
                      Discard
                    </Button>
                  )}

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      this.saveBankDetails();
                    }}
                    disabled={this.state.isButton || this.isPermission()}
                  >
                    {this.state.actionType === "edit"
                      ? "Save"
                      : this.state.activeTab === "general"
                        ? "Next"
                        : "Save"}
                  </button>
                </div>
              )}
            </div>
          </Container>

          {this.state.handleBankNotListedModal && (
            <Support
              supportEmail={"support@inn-flow.com"}
              supportDepartment={"All Other Modules"}
              summery={"Positive Pay Bank Not Listed"}
              hidValue={this.state.hotelID}
              closePopup={this.handleBankNotListedClose.bind(this)}
            ></Support>
          )}

          {this.state.isSpinner && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
          {this.state.isOtpNeed && (
            <OtpModal
              closePopup={this.closeOtpModal.bind(this)}
              ValidateOTP={this.ValidateOTP.bind(this)}
              ReSendOTP={this.ReSendOTP.bind(this)}
              purpose={"Bank Validation"}
            ></OtpModal>
          )}
          {this.state?.showChoiceModal && (
            <FundingOptionModal
              handleShowHideChoiceModal={this.handleShowHideChoiceModal}
              plaidFunction={this.plaidFunction}
              showChoiceModal={this.state?.showChoiceModal}
              bankName={this.state.formData.bankName}
              accountNo={this.state.formData.obaccno}
              accountName={this.state.formData.accountName}
              hotelID={this.state.hotelID}
              bankRefID={this.state.formData.id}
              PlaiddSetupStatus={this.PlaiddSetupStatus.bind(this)}
              oprID={this.props.oprID}
              bindFormData={this.bindFormData.bind(this)}
            />
          )}
          {this.state.showVerifyModal && (
            <VerifyMicroDepositModal
              handleVerifyModal={this.handleVerifyModal}
              plaidFunction={this.plaidFunction}
              showVerifyModal={this.state?.showVerifyModal}
              bankName={this.state.formData.bankName}
              accountNo={this.state.formData.obaccno}
              accountName={this.state.formData.accountName}
              hotelID={this.state.hotelID}
              bankRefID={this.state.formData.id}
              fundingSource={this.state.fundingSource}
              PlaiddSetupStatus={this.PlaiddSetupStatus.bind(this)}
            />
          )}
        </div>
      </div>
    );
  }
  changeBankSyncOn = (checked) => {
    if (!this.state.isBankSyncDone && this.state?.plaidConnectionStatus?.toLowerCase() !== "reconnect")
      this.setState({ bankSyncOn: checked });
  }
  handleCancelSetup = () => {
    this.setState({ bankSyncOn: false })
  }
  callBackBankSetup = (status) => {
    this.setState({ isBankSyncDone: status, isUpdatation: true }, () => {
      this.PlaidSetupDetails();
    });
  }
  closeSlideoutReconnect = () => {
    this.props.hideSlideOut(1);
  }
}
